import { SvgIcon, SxProps } from "@mui/material";

export default function IconArrowHead(sx?: SxProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 376.838 504.021">
            <g
                id="black_and_white_arrowhead"
                data-name="black and white arrowhead"
                transform="translate(-54.016 -33.155)"
            >
                <path
                    id="Path_61759"
                    data-name="Path 61759"
                    d="M156.979,418.006c-19.365-31.875-37.353-64.536-49.8-99.754-10.311-29.168-18.852-58.962-27.742-88.87a26.239,26.239,0,0,1,4.653-.818c1.03,4.044,1.972,7.74,2.934,11.735.34.766.66,1.234.986,2.1.669,2.8,1.331,5.2,2.031,7.973,3.695,11.267,7.4,22.152,10.993,33.073,3.025,9.2,5.628,18.541,8.956,27.622,2.944,8.033,6.694,15.769,9.975,23.682,4.343,10.475,8.169,21.186,12.977,31.439a274.681,274.681,0,0,0,14.51,26.506c5.493,8.986,11.651,17.567,17.595,26.273a12.385,12.385,0,0,0,2.633,2.2c.855-4.281.579-8.687,2.591-11.394,2.127-2.863,6.431-4.108,10.763-6.63-.68-.967-1.748-2.507-2.838-4.029-1-1.389-2.11-2.7-3-4.155-.716-1.174-1.072-2.565-1.76-3.76-2.8-4.873-7.767-1.489-10.457-2.778l-6.95,5.275q-1.809-3.47-3.615-6.942a1,1,0,0,1-.152-.472c.433-7.342-2.948-15.273,3.114-21.277a106.814,106.814,0,0,1-3.994-9.989,38.336,38.336,0,0,0,10.8,8.063c6.66,3.147,5.446,11.055,7.788,16.841.657,1.622.709,3.541,1.564,5.02,2.241,3.877,7.864,5.73,6.872,11.573-.038.222.315.632.581.767,7.831,3.977,12.1,13.524,22.218,14.092,1.417.08,3.191,1.846,4,3.282,3.24,5.759,7.726,8.959,14.556,8.388a14.763,14.763,0,0,1,3.244.325c.965,2.29,1.239,4.964,2.523,5.6a49.424,49.424,0,0,0,11.531,3.931c3.324.713,6.682.377,8.047-3.858.229-.709,1.7-1.017,2.6-1.511.228,1.149.942,2.474.6,3.415-1.367,3.749-3.064,7.379-4.8,11.435,2.572.725,4.159,1.592,5.715,1.54,7.688-.258,15.392-.544,23.03-1.369,1.39-.15,3.075-2.667,3.639-4.409,1.564-4.839-1.712-7.325-3.014-7.056a59.446,59.446,0,0,1,3.4-6.884c1.072,1.339,1.872,2.481,2.758,3.746,3.281-4.626,2.684-6.33-1.99-7.31,2.1-3.4,4.138-6.459,6.248-9.462.755-1.075,2.163-1.9,2.465-3.047,1.259-4.8,4.813-3.894,8.349-4.034a108.842,108.842,0,0,0,17.744-1.767c2.954-.612,4.751-3.477,3.115-7.066-.723-1.586-1.236-3.268-2-5.334,2.33-.79,4.369-1.117,5.966-2.137,1.3-.831,2.07-2.491,3.076-4.117a4.537,4.537,0,0,1,.249-1.865c-1.435-3.683-3.287-7.067,1.132-10.215.474-.337-.563-3.513-1.535-4.94-.825-1.211-2.568-1.8-3.452-2.367,1.343-2.771,3.45-5.141,3.3-7.36-.152-2.271-2.514-4.394-4.061-6.821l7.148-5.6c.94,2.124,1.282,4.027,2.4,5.178,2.221,2.288,4.639,5.258,7.418,5.844,2.066.436,6.027-1.884,7-3.975a17.6,17.6,0,0,0,1.158-10.66c-1.35-5.882,2-9.274,5.2-13.324l-1.693-3.752c3.721-1.419,8.458-7.957,8.758-11.661a11.127,11.127,0,0,1,.8-3.85,37.372,37.372,0,0,0,3.283-18.3c-.075-1.626,1.213-3.315,1.875-4.975l1.482.132a16.149,16.149,0,0,1,1.2,4.01c-3.551,2.413-3.348,5.757-2.116,8.6,1.708,3.936,4.257,7.508,6.451,11.616.857,1.338,1.678,3.1,2.565,3.131,12.15.466,12.236.439,16.686-11.17,1.8-4.707,3.817-9.495,4.512-14.418.6-4.223-1.931-9.1,3.753-11.654.3-.134.311-.887.476-1.345,2.385-6.626,4.837-13.229,7.132-19.886,1.109-3.215,1.882-6.543,2.894-9.793.409-1.313,1.052-2.553,1.588-3.826.845,1.167,1.683,2.339,2.54,3.5.289.39.626.745.942,1.116-5.3,17.812-10.2,35.758-16,53.406a460.144,460.144,0,0,1-38.468,87.128c-10.041,16.255-19.371,32.228-29.541,47.647-8.863,13.438-18.673,26.252-28.056,39.359.009.018-.006-.024-.265.128-1.773,2.174-3.287,4.2-5.108,6.36-14.463,16.062-28.618,31.982-43.146,47.964-3.9,2.3-6.767.231-9.938-1.657a40.913,40.913,0,0,1-3.6-3.029c-8.638-9.766-17.218-19.585-25.929-29.71-2.1-2.771-4.2-5.129-6.037-7.682q-24.055-33.441-48.029-66.941M342.7,387.891a44.738,44.738,0,0,1,3.92-5.912c3.839-4.222,2.29-9.208,2.383-14.724a13.4,13.4,0,0,1,1.585-4.315c.138-.646.276-1.293.507-2.719.477-2.234,2.478-4.8-1.027-6.281-3.015-1.274-5.853-1.9-8.267,1.581-.907,1.307-3.159,1.681-5.615,2.48l-7.592,1.872c3.337,2.76,5.373,4.444,7.7,6.731a22.06,22.06,0,0,1,4.691,4.185c-.625,2-1.066,5.648-1.9,5.742-4.954.553-6.316,5.211-9.395,7.73-1.215.994-.591,4.505-.319,6.813.052.445,2.363.625,4.441.927,1.73-.333,3.461-.667,5.872-1.068a14.567,14.567,0,0,1,3.016-3.041m31.224-66.632c-1.777-1.415-3.451-3.833-5.352-4.028-3.5-.358-7.6-.3-10.579,1.253a13.952,13.952,0,0,0-6.472,7.825c-.965,3.595.226,7.768-.268,11.786-2.8,1.3-3.21,3.581-1.221,5.449.879.825,3.782,3.474,5.638-.544a2.854,2.854,0,0,1,1.747.517,55.412,55.412,0,0,0,3.883-4.109,45.507,45.507,0,0,1,5.378-4.5A28.84,28.84,0,0,0,369,330.333a1.533,1.533,0,0,1,.682-1.433,59.271,59.271,0,0,0,4.239-7.641M260.542,510.077q12.428-15.885,24.845-31.78c1.7-2.188,4.564-4.457,4.633-6.757.225-7.529,6.447-11.132,9.608-16.67,1.6-2.807,2.61-6.21,4.841-8.347a25.685,25.685,0,0,0,7.726-13.964c.572-2.779,1.842-6.666,3.921-7.634,5.072-2.36,5.74-4.751,2.468-8.948-.553-.709-.23-2.095-.776-2.818a24.5,24.5,0,0,0-3.264-3.067c-.846,1.223-2.5,2.515-2.4,3.658.427,5-2.368,7.524-6.146,9.862a19.352,19.352,0,0,0-4.7,4.854c-2.942,3.832-5.632,7.858-8.565,11.7-1.823,2.387-4.63,4.285-5.694,6.927-1.573,3.9-2.931,7.1-7.731,7.853-1.879.295-3.511,2.245-5.224,3.485-2,1.447-3.773,3.419-5.988,4.3-2.808,1.114-4.473,2.315-5.579,5.482-1.123,3.218-4.06,5.8-6.155,8.6-5.919-2.683-11.308-6.219-17.2-7.568-12.236-2.8-21.68-9.469-29.937-18.411-1.789-1.937-5-3.548-5.33-5.66-.942-5.964-4.894-5.5-8.847-5.125-8.451.8-14.166-2.437-18.054-10.143-1.211-2.4-1.981-7.993-8.439-4.848a45.281,45.281,0,0,0,2.921,5.837c2.244,3.261,4.871,6.258,7.144,9.5,2.445,3.489,4.489,7.267,7.036,10.674,2.474,3.311,5.54,6.177,8.037,9.473,6.421,8.476,12.3,17.386,19.077,25.562,9.5,11.465,19.591,22.437,29.465,33.589,2.613,2.952,5.75,3.524,8.7.755,3.262-3.056,6.162-6.5,9.6-10.372M193,415.165c-3.7,2.052-1.525,5.034-.168,6.568,1.1,1.248,4.629,1.893,5.946,1.045,1.858-1.2,2.67-4.019,3.93-6.146-1.989-.577-3.957-1.25-5.975-1.689a13.986,13.986,0,0,0-3.732.223m125.992-9.48-.192,2.993,2.6-.823a5.437,5.437,0,0,0-2.409-2.17M346.5,346.827l1.111-2.063-1.7-.451a3.654,3.654,0,0,0,.588,2.514M325.732,354.9l-1.5.165.345,1.343A2.618,2.618,0,0,0,325.732,354.9Z"
                    fill="#050506"
                />
                <path
                    id="Path_61760"
                    data-name="Path 61760"
                    d="M90,250a62.081,62.081,0,0,1-1.764-7.778A4.633,4.633,0,0,0,87,240l-2.913-11.437c-1.108.112-2.663.269-4.615.421-2.939-9.075-5.482-18.145-7.735-27.567,5.34,1.83,4.025,6.915,5.136,10.774,1.334,4.638,4.706,8.791,8.789,9.272a11.591,11.591,0,0,0,.286-2.9c-2.751-17.786-5.2-35.629-8.464-53.322-2.537-13.769-3.2-21.368,16.705-25.175,9.652-1.846,19.857-.8,29.85-.769a5.691,5.691,0,0,0,1.264,1.255,6.676,6.676,0,0,1,.993-1.686,21.469,21.469,0,0,1,3.156-.88c4.812-.331,9.176-.667,13.739-.746a12.6,12.6,0,0,0,3.166-1.38c4.787-1.052,9.216-1.947,13.708-2.494,2.768,2.8,4.2,1.685,5.263-1.4a3.787,3.787,0,0,1,1.824.244c4.511,3.107,5.662-.088,7.067-3.5a44.146,44.146,0,0,1,7.97-2.466c2.77,2.588,5.479,1.654,7.356-.248,1.545-1.566,5.336-2.342,3.64-6.29,13.352-8.574,24.3-19.46,34.373-31.07,6.565-7.566,11.676-16.393,17.747-24.515,6.443,8.381,12.578,16.621,18.464,25.055,3.448,5.421,7.035,10.733,10.968,15.776.546.7,2.792.076,4.553.205,4.445,3.7,8.586,7.263,12.453,11.058-.526,4.813,8.765,12.073,14.1,11.753a7.151,7.151,0,0,1,4.342,1.5c2.517,1.921,4.371,2.893,5.134-1.445a6.73,6.73,0,0,1,2.632,1.317c-.251,1.68-.454,3.037-.658,4.394.99.143,2.257.734,2.91.331,1.132-.7,1.884-2.012,3.182-3.029,4.463,1.028,8.539,2.017,12.622,3.361a15.435,15.435,0,0,0,1.365,2.437,9.028,9.028,0,0,1,2.051-1.828c9.81,1.013,19.194,2.032,28.588,3.431,2.564,1.753,4.99,3.512,7.7,4.4,2.937.957,4.767-.411,4.742-3.838a109.685,109.685,0,0,1,11.62,1.3c2.008,1.421,3.907,3.139,5.94,3.316,1.573.137,3.314-1.654,5.335-2.557a74.222,74.222,0,0,1,8.46,7.089,15.425,15.425,0,0,0,2.461,3.153c.408,3.709,1.2,7.218.652,10.5-1.686,10.115-3.885,20.146-6.188,30.24a5.723,5.723,0,0,0-1.3,1.239A3.619,3.619,0,0,1,409,194.438a51.64,51.64,0,0,1-.3,6.858c-.857,9.644-1.482,19,.462,27.157l5.789,2.535c-1.115,4.577-2.23,9.153-3.6,13.887a2.55,2.55,0,0,1-1.2-.959c-.857-1.158-1.695-2.33-2.54-3.5-.536,1.273-1.179,2.513-1.588,3.826-1.013,3.25-1.786,6.579-2.894,9.793-2.3,6.657-4.747,13.26-7.132,19.886-.165.458-.177,1.211-.476,1.345-5.684,2.551-3.157,7.431-3.753,11.654-.695,4.923-2.708,9.711-4.512,14.418-4.45,11.609-4.535,11.636-16.686,11.17-.887-.034-1.708-1.793-2.185-3.141,7.941-5.8,9.009-9.5,4.974-17.712,2.56,0,6.1.881,6.88-.209,1.137-1.6.293-4.605.293-7.618a18.336,18.336,0,0,1-4.494,1.8c1.687-6.472,3.223-12.612,5.066-18.659.451-1.481,1.9-2.658,2.888-3.574-.479,3.62-.95,6.84-1.464,10.351,3.179-2.449,5.6-3.91,7.467-5.887,1.353-1.429,3.207-4,2.729-5.273-2.345-6.239-.47-12.252-.023-18.359.075-1.019-.7-2.1-1.14-3.327A22.281,22.281,0,0,1,387,243.582c2.516-13.517,5.345-26.567,7.433-39.734,1.3-8.194,4.528-16.206,2.672-24.839a25.921,25.921,0,0,1,.106-8.943,12.074,12.074,0,0,0-11.63-14.092c-1.639-.034-3.269-.419-4.908-.582-7.952-.791-15.9-1.627-23.86-2.318-5.867-.509-11.908-.115-17.593-1.378-8.927-1.984-17.672-4.858-26.4-7.658-12.143-3.9-24.131-8.254-34.5-15.975-1.735-1.293-2.9-3.356-3.976-5.029,1.349.176,2.349.319,4.578.637l-3.787-5.433-.931.474a16.939,16.939,0,0,1-.58,4.284c-1.276-.338-2.39-.44-3.05-1.04-5.148-4.685-10.2-9.475-15.3-14.213-1.733-1.61-3.517-3.163-5.288-5.129-2.41-3.767-5.584-4.255-8.392-1.613-6.306-.582-7.252,3.913-8.6,8.333a4.362,4.362,0,0,1-.219,1.775c-.493.307-.68.569-1.163.892-5.7.827-8.4,4.647-10.737,9.266a5.59,5.59,0,0,1-2.2,1.593c-3.744-4.422-7.6-4.377-11.793-1.32a4.424,4.424,0,0,1-1.779.856c-5.447.883-6.9,4.325-6.116,9.3.577,3.638-1.347,5.191-4.587,6.445-3.964,1.534-7.618,3.87-11.839,5.859-6.144,1.667-11.856,3.333-17.9,5a4.411,4.411,0,0,1-1.881-.262c-1.072.579-1.929,1.421-3.161,2.262h-3.009c-3.795,1-7.205,2-11.08,3-6.155.333-11.845.666-17.8.713-2.423-.429-4.577-.571-6.795-1.069a76.879,76.879,0,0,0-7.227-4.05c-.687,1.771-1.2,3.088-1.709,4.739a2.338,2.338,0,0,1-.4,1.717,55.6,55.6,0,0,1-5.665.918c-6.491.319-9.813,3.612-10.212,10.271-.76,2.746-1.24,5.254-1.971,7.975-.228,2.614-.117,4.948,3.251,5.222.662,3.97,1.489,7.483,1.952,11.043,1.107,8.5,2.043,17.013,2.8,25.7a14.048,14.048,0,0,0,.25,3.15c0,.778,0,1.222,0,2.067,0,1.467,0,2.533,0,3.938.334,1.113.666,1.887,1,3.037a9.615,9.615,0,0,1-.279,2.874c-.1,2.67.279,5.1.186,7.508a5.872,5.872,0,0,1-1.536,3.006c-6.163-2.127-8.534,1.481-10.156,6.427-.119.364-.8.544-1.214.81M241.688,74.922c.231.563.512,1.631.685,1.614,2.32-.232,4.625-.615,7.679-1.072-.662-.746-1.517-2.511-2.374-2.511-1.848,0-3.7.9-5.991,1.969M401.8,186.663h2.673l.939-1.377-2.755-2.673-1.344.866a8.439,8.439,0,0,0,.488,3.184M226.392,98.657l3.207-1.388-.508-1.139c-1.2.643-3.873-2.066-2.7,2.526m179.223,92.278h-4.493l.372,1.815a14.4,14.4,0,0,0,4.121-1.815M392.7,225.523l-.308,2.9,1.39-.065a5.089,5.089,0,0,0-1.081-2.83m-87.97-88.4-.578-1.633-.837.383c.326.56.653,1.12,1.415,1.25m87.134,99.39-1.283-.911-.342,1.348a1.808,1.808,0,0,0,1.625-.437M273.609,111.8l-1.184-.013c0,.164-.014.47,0,.471a1.2,1.2,0,0,0,1.187-.458M405.7,237.569l.858-.819c-.113-.118-.319-.346-.326-.339a1.209,1.209,0,0,0-.531,1.158m-8-39,.858-.819c-.113-.118-.319-.346-.326-.339A1.209,1.209,0,0,0,397.7,198.569Z"
                    fill="#070707"
                />
                <path
                    id="Path_61761"
                    data-name="Path 61761"
                    d="M409.041,192.015c2-10.063,4.2-20.093,5.885-30.209.548-3.286-.244-6.795-.662-10.855a24.207,24.207,0,0,0-2.175-3.019A113.467,113.467,0,0,0,402.946,141c-4.148-.416-7.534-.74-10.921-1.063-3.7-.312-7.408-.625-12.017-.939s-8.307-.619-12.008-.927c-9.384-1.02-18.767-2.04-28.87-3.183-1.523-.36-2.326-.6-3.13-.834-4.076-.989-8.152-1.978-12.923-3.149-2.156-.746-3.618-1.311-5.08-1.875-.786-.324-1.572-.649-3-1.147-8.089-4.08-15.534-7.985-22.98-11.891-4.142-3.561-8.283-7.122-12.869-11.127-5.34-5.586-10.235-10.73-15.13-15.873-6.135-8.24-12.27-16.48-18.863-25.157a40.052,40.052,0,0,0-6.86-.8c1.251-2.966,2.494-6.147,3.921-9.242,2.214-4.8,4.548-4.879,7.865-.687q10.4,13.147,21.12,26.042c.649.778,2.528.531,3.836.76,8.036,7.659,15.594,15.912,24.209,22.853,17.642,14.215,38.557,20.062,60.859,21.094,8.28.383,16.622-.209,24.92-.648,10.076-.533,19.966.066,29,4.968,9.166,4.975,15.446,12.332,16.57,23.489-1.46,1.854-3.051,3.133-3.41,4.694-1.99,8.66-3.691,17.387-5.47,26.095-1.63,7.979-3.9,15.506-12.718,18.552,0-2.042.007-4.084.016-6.894C409.024,192.9,409.033,192.456,409.041,192.015Z"
                    fill="#202020"
                />
                <path
                    id="Path_61762"
                    data-name="Path 61762"
                    d="M129,137.984c-.8.253-1.609.506-3.042.884A14.755,14.755,0,0,1,124,139c-9.955.265-20.159-.778-29.812,1.068-19.9,3.807-19.242,11.406-16.705,25.175,3.26,17.694,5.714,35.536,8.464,53.322a11.591,11.591,0,0,1-.286,2.9c-4.083-.481-7.454-4.633-8.789-9.272-1.11-3.86.2-8.944-5.2-11.146-3.562-13.725-6.86-27.411-9.909-41.151-.74-3.334-.655-6.85-.9-11.025a25.557,25.557,0,0,1,9.84-18.532c9.8-8.063,21.43-7.289,33.161-7.163,14.162.152,28.533.584,42.459-1.486,22.589-3.357,42.8-12.931,58.447-30.124,9.5-10.443,18.1-21.711,27.435-32.559.151,1.522.452,3.329-.3,4.407-2.811,4.049-6.024,7.815-8.98,11.768-10.75,14.376-22.849,27.559-38.792,36.032-10.194,5.418-21.315,9.341-32.37,12.823-11.934,3.758-24.263,6.261-36.955,6.033-1.181-.021-2.377.816-3.565,1.254l.225,1.3c3.844.461,7.782.556,11.5,1.52C125.165,134.711,127,136.657,129,137.984Z"
                    fill="#181818"
                />
                <path
                    id="Path_61763"
                    data-name="Path 61763"
                    d="M129.451,137.989c-2.447-1.332-4.286-3.277-6.482-3.848-3.713-.965-7.651-1.06-11.5-1.52l-.225-1.3c1.189-.439,2.385-1.275,3.565-1.254,12.692.228,25.021-2.275,36.955-6.033,11.055-3.482,22.176-7.405,32.37-12.823,15.943-8.473,28.042-21.657,38.792-36.032,2.955-3.952,6.168-7.719,8.98-11.768.749-1.078.448-2.885.431-4.72a10.368,10.368,0,0,1,1.891-3.091q5.847-6.811,11.734-13.587c7.77,10.551,15.491,21.139,23.351,31.622,1.562,2.083,3.659,3.765,5.614,5.95-1.2.09-3.081.337-3.73-.441Q260.464,66.271,250.082,53.1c-3.317-4.192-5.652-4.112-7.865.687-1.428,3.1-2.67,6.276-3.921,9.242a49.6,49.6,0,0,1,6.551.662c-5.613,8.558-10.723,17.386-17.289,24.952-10.075,11.61-21.021,22.5-34.691,31.212-3.97,2.313-7.427,4.212-10.885,6.111-2.513.827-5.026,1.654-8.136,2.76-2.692,1.256-4.788,2.233-6.884,3.209-.436.008-.872.016-2.008.038-2.118.359-3.535.7-4.953,1.046-4.429.895-8.859,1.79-13.983,2.836-1.472.477-2.25.8-3.027,1.129C138.627,137.322,134.263,137.658,129.451,137.989Z"
                    fill="#1c1c1c"
                />
                <path
                    id="Path_61764"
                    data-name="Path 61764"
                    d="M246.285,41.88c-4.232,4.66-8.155,9.18-12.053,13.72a32.855,32.855,0,0,0-2.223,3.041c-9.138,11.211-17.735,22.479-27.238,32.922-15.647,17.194-35.859,26.767-58.447,30.124-13.926,2.07-28.3,1.638-42.459,1.486-11.731-.126-23.358-.9-33.161,7.163-5.586,4.595-9.174,10.4-9.9,18.115-4.967,2.053-4.621,6.225-4.714,10.173a31.819,31.819,0,0,1-.366,5.468c-5.35-19.587,2.037-36.509,19.522-44.58a28.3,28.3,0,0,1,11.513-2.392c11.771-.011,23.552,1.008,35.312.772,19.2-.386,37.8-3.674,55.076-12.876a99.752,99.752,0,0,0,32.7-27.782c10.659-13.925,21.119-28,31.609-42.055,1.792-2.4,3.842-2.628,5.943-.879,1.605,1.336,2.807,3.157,4.541,5.172C249.829,40.371,248.217,41.059,246.285,41.88Z"
                    fill="#f7f7f7"
                />
                <path
                    id="Path_61765"
                    data-name="Path 61765"
                    d="M156.609,418c16.373,22.324,32.362,44.653,48.4,66.947,1.836,2.553,3.942,4.911,5.658,7.694-1.537-.3-3.126-.646-4.025-1.625-3.089-3.365-5.7-7.2-8.946-10.381-2.923-2.865-6.45-5.113-9.711-7.633-16.946-22.506-33.381-45.347-47.216-69.9l1.812-1.353c3.257,4.327,6.446,8.708,9.813,12.949A17.394,17.394,0,0,0,156.609,418Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_61766"
                    data-name="Path 61766"
                    d="M408.7,201.3c9.113-3.341,11.383-10.868,13.013-18.847,1.779-8.708,3.48-17.435,5.47-26.095.359-1.562,1.95-2.84,3.335-4.3a13.262,13.262,0,0,1,.082,5.586,18.268,18.268,0,0,0-.573,4.368,7.6,7.6,0,0,1-.406,2.661,6.8,6.8,0,0,0-.525,2.364,6.812,6.812,0,0,1-.57,2.705,20.659,20.659,0,0,0-.794,4.891c-.574,3.517-1.149,7.035-2.1,11a7.124,7.124,0,0,0-.509,2.412c-3.229,14.122-6.458,28.244-9.928,42.656a33.074,33.074,0,0,1-6.03-2.245C407.217,220.291,407.842,210.94,408.7,201.3Z"
                    fill="#181818"
                />
                <path
                    id="Path_61767"
                    data-name="Path 61767"
                    d="M299.018,472.554c9.392-13.089,19.2-25.9,28.065-39.341,10.17-15.419,19.5-31.392,29.5-47.3.709,2.041,1.683,2.5,3.092.573,1.017-1.387,1.8-2.946,2.688-4.429l1.274.559a14.548,14.548,0,0,1-1.09,3.092c-10.162,16.118-20.256,32.28-30.643,48.252-3.1,4.764-7.046,8.977-11.007,13.915a9.237,9.237,0,0,0-.9,2.13c-3.12,4.225-6.24,8.449-9.892,12.938A4.118,4.118,0,0,0,309,464.014s0-.017-.245.15a8.237,8.237,0,0,0-.754,1.858,73.662,73.662,0,0,1-5.353,6.667A14.158,14.158,0,0,1,299.018,472.554Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_61768"
                    data-name="Path 61768"
                    d="M250.882,526.963c14.155-15.92,28.31-31.841,42.977-47.629,1.389.311,2.267.49,3.143.667h0c-3.422,4.584-6.667,9.314-10.3,13.723-8.287,10.05-16.765,19.942-25.816,30.092C257.116,524.994,254,525.979,250.882,526.963Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61769"
                    data-name="Path 61769"
                    d="M250.508,527.023c3.491-1.045,6.608-2.029,10.106-3.018a79.687,79.687,0,0,1-7.3,9.105c-4.827,5.017-9.017,5.559-13.786.68-7.51-7.684-14.349-16.023-21.161-24.4,4.488,3.562,8.514,7.621,12.9,11.252,2.758,2.286,4.958,6.051,9.543,5C243.741,527.254,246.605,529.321,250.508,527.023Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61770"
                    data-name="Path 61770"
                    d="M240.57,525.367c-4.349,1.325-6.549-2.439-9.307-4.726-4.381-3.631-8.407-7.69-12.938-11.6-.354-.028-.328-.036-.333-.4-1.093-5.482-4.4-8.647-9.044-10.632-6.886-8.136-13.772-16.271-20.811-24.708,3.107,2.219,6.635,4.467,9.558,7.331,3.25,3.185,5.857,7.016,8.946,10.381.9.979,2.488,1.324,4.14,1.947,8.976,9.791,17.555,19.609,26.194,29.376A40.913,40.913,0,0,0,240.57,525.367Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61771"
                    data-name="Path 61771"
                    d="M209,498.356a12.993,12.993,0,0,1,8.987,10.3C215.007,505.583,212.028,502.142,209,498.356Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61772"
                    data-name="Path 61772"
                    d="M299.027,472.572c.984.122,1.977.261,3.473.413a44.444,44.444,0,0,1-5.2,6.869c-.3.148-.3.146-.3-.231.675-2.61,1.346-4.842,2.018-7.075C299.021,472.548,299.036,472.589,299.027,472.572Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61773"
                    data-name="Path 61773"
                    d="M430.265,161.745a8.365,8.365,0,0,1,.246-3.683A8.365,8.365,0,0,1,430.265,161.745Z"
                    fill="#202020"
                />
                <path
                    id="Path_61774"
                    data-name="Path 61774"
                    d="M427.886,174.33a12.7,12.7,0,0,1,.543-4.23A12.7,12.7,0,0,1,427.886,174.33Z"
                    fill="#202020"
                />
                <path
                    id="Path_61775"
                    data-name="Path 61775"
                    d="M425.359,187.869a2.316,2.316,0,0,1,.176-1.834A2.316,2.316,0,0,1,425.359,187.869Z"
                    fill="#202020"
                />
                <path
                    id="Path_61776"
                    data-name="Path 61776"
                    d="M429.326,166.854a2.353,2.353,0,0,1,.2-1.82A2.352,2.352,0,0,1,429.326,166.854Z"
                    fill="#202020"
                />
                <path
                    id="Path_61777"
                    data-name="Path 61777"
                    d="M57.045,166.394a1.85,1.85,0,0,1,.21,1.185c0,.011-.307,0-.471,0A2.059,2.059,0,0,1,57.045,166.394Z"
                    fill="#f7f7f7"
                />
                <path
                    id="Path_61778"
                    data-name="Path 61778"
                    d="M57.6,172.281a.793.793,0,0,1-.21-.573A.793.793,0,0,1,57.6,172.281Z"
                    fill="#f7f7f7"
                />
                <path
                    id="Path_61779"
                    data-name="Path 61779"
                    d="M59.4,179.721a.788.788,0,0,1,.208.57A.788.788,0,0,1,59.4,179.721Z"
                    fill="#f7f7f7"
                />
                <path
                    id="Path_61780"
                    data-name="Path 61780"
                    d="M58.6,176.279a.787.787,0,0,1-.208-.569A.787.787,0,0,1,58.6,176.279Z"
                    fill="#f7f7f7"
                />
                <path
                    id="Path_61781"
                    data-name="Path 61781"
                    d="M308.245,465.849a2.739,2.739,0,0,1,.519-1.684A2.74,2.74,0,0,1,308.245,465.849Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61782"
                    data-name="Path 61782"
                    d="M320.241,449.838a2.665,2.665,0,0,1,.5-1.651A2.665,2.665,0,0,1,320.241,449.838Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61783"
                    data-name="Path 61783"
                    d="M309.225,463.9c-.032-.158.16-.427.581-.8C309.919,463.323,309.724,463.589,309.225,463.9Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61784"
                    data-name="Path 61784"
                    d="M102,217c-1-8.509-1.941-17.026-3.047-25.521-.464-3.56-1.291-7.073-1.987-11.347-.345-2.2-.655-3.667-.966-5.539,0-2.8,0-5.2,0-7.593.118-6.42,3.441-9.713,9.932-10.033,1.764-.087,3.508-.568,6.131-.918,5.893-.383,10.915-.717,15.937-1.05,5.691-.333,11.381-.667,17.759-.744A104.475,104.475,0,0,0,157,151h6.334c.778,0,1.222,0,2.031-.038,2.455-.679,4.545-1.321,7.035-1.963,2.8-.667,5.2-1.333,7.9-2.02.766-.34,1.234-.66,2.106-.98,5.135-1.667,9.865-3.333,14.937-5.03,1.78-1.01,3.22-1.99,5.014-3.006,7.451-5.679,14.549-11.321,21.946-17.109,2.767-3.048,5.233-5.951,7.7-8.854.1-.323.288-.585,1.1-.918A20.358,20.358,0,0,0,236,109l.3-.15c1.433-2.05,2.567-3.95,3.959-5.956a11.451,11.451,0,0,1,2.157-.893c2.805.333,5.195.667,7.584,1,1.761,1.579,3.545,3.133,5.278,4.743,5.1,4.738,10.153,9.528,15.3,14.213.66.6,1.774.7,3.05,1.04,1.8,1.712,2.96,3.774,4.7,5.067,10.366,7.721,22.354,12.077,34.5,15.975,8.725,2.8,17.47,5.675,26.4,7.658,5.685,1.263,11.726.869,17.593,1.378,7.961.691,15.909,1.527,23.86,2.318,1.64.163,3.269.548,4.908.582a12.074,12.074,0,0,1,11.63,14.092,25.921,25.921,0,0,0-.106,8.943c1.857,8.633-1.372,16.645-2.672,24.839-2.089,13.167-4.917,26.216-7.479,40.123a56.692,56.692,0,0,1-1.225,7.258,44.057,44.057,0,0,0-1.729,6.2c0,2.143,0,3.857,0,5.572-.992,1.316-2.445,2.493-2.9,3.974-1.842,6.047-3.378,12.187-5.376,18.812-3.659,3.457-6.9,6.706-11.728,3.214l-1.53-3.842-1.482-.132c-.662,1.66-1.949,3.349-1.875,4.975a37.372,37.372,0,0,1-3.283,18.3,11.127,11.127,0,0,0-.8,3.85c-.3,3.7-5.037,10.243-8.758,11.661l1.693,3.752c-3.206,4.05-6.555,7.441-5.2,13.324a17.6,17.6,0,0,1-1.158,10.66c-.974,2.091-4.936,4.41-7,3.975-2.779-.586-5.2-3.556-7.418-5.844-1.117-1.151-1.459-3.054-2.4-5.178l-7.148,5.6c1.547,2.427,3.909,4.55,4.061,6.821.148,2.219-1.958,4.589-3.3,7.36.884.571,2.627,1.156,3.452,2.367.971,1.426,2.008,4.6,1.535,4.94-4.419,3.148-2.566,6.532-1.486,10.215a5.875,5.875,0,0,1-2.976-.107c-5.8-2.707-11.364-5.114-17.2-7.637a2.317,2.317,0,0,1,.774-2.049h16.419l.23-1.711-12.107-3.418.4-3.912-12.56,1.483,6.218,3.985c-1.488,1.187-2.471,1.971-3.771,3.012a30.306,30.306,0,0,1-3.958.825l1.368,9.111-7.558,1.431,3.976,5.784-1.73,8.08,5.729,5.1V388.16c3.713.194,2.621-3.574,3.806-6.13,4.792-.112,2,4.023,3.913,6.4,4.439-4.587,10.14-5.506,16.37-5.067A13.967,13.967,0,0,0,322,384c-1.005,1.293-1.775,2.953-3.076,3.784-1.6,1.02-3.636,1.347-5.966,2.137.767,2.066,1.28,3.748,2,5.334,1.636,3.589-.161,6.454-3.115,7.066A108.842,108.842,0,0,1,294.1,404.09c-3.535.139-7.09-.767-8.349,4.034-.3,1.15-1.71,1.972-2.465,3.047-2.11,3-4.145,6.059-6.374,9.757-.414,1.466-.664,2.269-.914,3.073l-3.128,7.081c1.3-.269,4.579,2.217,3.014,7.056-.563,1.743-2.248,4.259-3.639,4.409-7.639.825-15.342,1.112-23.03,1.369-1.556.052-3.143-.815-5.715-1.54,1.739-4.057,3.435-7.686,4.8-11.435.343-.94-.371-2.266-.6-3.415-.9.493-2.372.8-2.6,1.511-1.364,4.235-4.723,4.571-8.047,3.858a49.424,49.424,0,0,1-11.531-3.931c-1.285-.638-1.559-3.312-2.523-5.6a14.763,14.763,0,0,0-3.244-.325c-6.829.572-11.316-2.628-14.556-8.388-.808-1.436-2.582-3.2-4-3.282-10.119-.568-14.386-10.115-22.218-14.092-.266-.135-.619-.545-.581-.767.991-5.844-4.632-7.7-6.872-11.573-.855-1.479-.907-3.4-1.564-5.02-2.343-5.787-1.129-13.694-7.788-16.841-4.28-2.023-7.437-4.737-11.068-8.252A11.17,11.17,0,0,1,149,350.593c-1.256-4.611-2.379-8.863-3.879-12.978-.3-.81-2.043-1.09-3.229-1.834a11.9,11.9,0,0,0-.932-1.145,26.175,26.175,0,0,1-1.375-5.031c3.9.68,7.378,1.344,10.981,2.032v4.755l10.243-4.6c-2.142-.741-3-1.038-3.882-1.754a11.073,11.073,0,0,1-1.2-2.583,28.215,28.215,0,0,1,4.321-.716c-.175-1.42-.63-2.606-.386-3.624a36.965,36.965,0,0,1,2.622-7.146,12.624,12.624,0,0,0,1.707-3.509c.854-1.826,1.647-3.292,3.084-5.948,2.247,8.075,4.1,14.742,5.948,21.773,0,.848.008,1.332.062,1.986.044.17,0,.517.044.934a15.614,15.614,0,0,1,1.514,2.455,59.483,59.483,0,0,0,1.652,6.921c-4.171,1.2-3.694,4.171-2.981,7.682a35.092,35.092,0,0,1,5.686.017,2.159,2.159,0,0,1-.391,1.571,18.262,18.262,0,0,0-.274,5.179,20.972,20.972,0,0,1,.314,4.005c-3.015.763-5.643,1.507-8.65,2.357a16.81,16.81,0,0,0,17.13.114,43.064,43.064,0,0,1-6.651-2.914,2.78,2.78,0,0,1,.964-1.982c.211-.107.187-.382.153-1.073a38.94,38.94,0,0,1,5.1-3.812,27.079,27.079,0,0,1-4.69-1.958,10.992,10.992,0,0,1,1.3-2.9,12.025,12.025,0,0,0,1.32-2.033,7.78,7.78,0,0,1-2.437-1.183c-.392-1.225-.784-2.1-1.172-3.127a3.61,3.61,0,0,1,.09-.789,7.752,7.752,0,0,1,1.308-2.746,11.084,11.084,0,0,0,2.532-3.364c-1.01-1.63-1.973-2.915-3.308-4.7l7.009-1.482c-2.167-.342-3.237-.51-4.109-1.154.287-1.5.376-2.521.659-3.836,6.193-2.47,1.412-3.846-.19-5.821a12.453,12.453,0,0,1,.093-2.014,1.616,1.616,0,0,1,1.232-.667,14.662,14.662,0,0,0,1.827-2.487c1.11-.968,2.256-1.48,2.775-2.36a49.432,49.432,0,0,0,2.443-5.428c1.035,1.739,2.081,3.47,3.1,5.219.468.8,1.259,1.64,1.257,2.46-.013,4.905,2.01,5.713,5.38,3.442,0-1.6.022-2.926-.008-4.248-.02-.878-.173-1.754-.16-2.63a15.254,15.254,0,0,1,.512-3.963,9.832,9.832,0,0,0,1.542-1.946c.008-.009.024-.029.192-.112a4.055,4.055,0,0,0-.182-1.287,18.91,18.91,0,0,0-.22-2.27c0-2,.1-3.656.21-5.647.006-.784.008-1.232.037-2.04a29.311,29.311,0,0,1,2.974-5.748,3.542,3.542,0,0,1,1.9.449c1.1,2.13,2.113,3.91,3.248,5.916-4,1.725-2.831,4.691-1.158,8.091a8.29,8.29,0,0,1-.277,2.653c-3.088,1.9-.709,2.849.269,4.178a.77.77,0,0,1-.3.708,15.692,15.692,0,0,0,3.374,2.38l-2.64,3.346a29.727,29.727,0,0,1,2.6,4.39,4.32,4.32,0,0,0-1.783,1.4c-.14,1.125-.248,1.974-.385,3.115-.025,1-.022,1.715-.1,2.819,4.942,4.623,4.942,4.623-.224,7.009l1.914,4.009-4.307,1.679.119,1.254c3.538.219,7.075.438,10.954.627a4.08,4.08,0,0,0,1.1-1.327c-.713-.081-1.426-.162-2.423-.208a5.655,5.655,0,0,1-1.994-.72c-.252-.4-.461-.562-.777-1a4.178,4.178,0,0,1,.261-1.791,4.715,4.715,0,0,0,.912-.97c2.845-1.885,5.386-3.571,8.469-5.616a16.877,16.877,0,0,1-3.784-1.671,3.748,3.748,0,0,1,.031-1.176c.986-1.8,1.866-3.283,2.81-5.253a21.316,21.316,0,0,0-.062-3.718c-1.667-1.154-3.185-2.017-4.354-2.681-.533-3.3,8.68-2.539,2.552-7.946a3.137,3.137,0,0,1,.2-1.224A17.712,17.712,0,0,1,227.344,301a9.5,9.5,0,0,0,2.075-.185,15.921,15.921,0,0,0,.563-4.1,13.129,13.129,0,0,1-.038-1.368c1.133-5.327,2.226-10.244,3.318-15.161l1.2.267c1.845,5.885,3.69,11.771,5.535,17.99a8.376,8.376,0,0,1-.253,2.544c1.825,2.524,1.676,5.249.951,8.256.7.76,1.635,1.3,2.483,2.205a39.947,39.947,0,0,1-2.974,3.51l2.123,2.49-2.9,3.394,7.407,2.6c1.19-3.935,2.154-7.124,3.129-10.675-.355-1.179-.722-2-1-3.169a32.9,32.9,0,0,1,2.364-5.6,5.228,5.228,0,0,1,2.577.421c.829,7.415,1.5,14.412,2.139,21.661a1.028,1.028,0,0,1-.353.883,3.348,3.348,0,0,0,.3,1.641,5.651,5.651,0,0,1-.183,1.617c2.426,2.628,5.022,4.234,8.091.658a33.494,33.494,0,0,1-4.512-1.967c1.435-.934,2.558-1.753,4-2.808-1.176-.726-2.623-1.347-2.56-1.623.581-2.551,1.423-5.042,2.184-7.9a8.242,8.242,0,0,1,.223-2.538,2.267,2.267,0,0,0,.727-1.36c-.024-1.306-.06-2.176-.075-3.4a89.046,89.046,0,0,1,1.368-9.3,2.45,2.45,0,0,1,1.225.148c1.038,2.792,1.764,5.381,2.49,7.97.673,2.4,1.346,4.8,2.02,7.547.012,1.04.024,1.734,0,2.755a16.218,16.218,0,0,1,.791,2.751c-.431.751-.607,1.328-1.059,2.093-.218,1.4-2.89,3.039.317,4.114a23.552,23.552,0,0,1,1.22,2.016c-.094.845-.086,1.442-.186,2.356a8.706,8.706,0,0,1-1.379,2.23,39.694,39.694,0,0,0,3.843,4.9,46.926,46.926,0,0,1-.973,6.129c-.8.113-1.3.226-1.795.339l.038.531a16.488,16.488,0,0,1,2.383.3,2.729,2.729,0,0,1,.825,1.851,5.441,5.441,0,0,0-.9,2.4,54.746,54.746,0,0,0,4.441,3.786,24.511,24.511,0,0,0-4.294,4.172c-3.184,2.279-3,5-.911,7.476.974,1.152,3,1.53,4.623,1.954.512.134,1.575-.571,1.881-1.156.91-1.74,1.568-3.611,2.082-4.847-1.592-1.122-3.565-2.513-5.151-3.891,2.646-1.661,4.9-3.336,7.8-5.484-2.951-1.17-4.774-1.893-6.7-2.828-.36-.617-.612-1.02-.5-1.524a28.445,28.445,0,0,0,4.118-1.321c3.4-1.693,3.724-3.961,2-5.486.963-4.468,3.284-8.73,2.091-11.453-1.315-3,.371-2.808,1.762-3.849a9.639,9.639,0,0,0,.5-3.485,30.967,30.967,0,0,1,2.441-5.6,3.132,3.132,0,0,1,1.845-.556c.817,2.644,1.371,4.982,2.078,7.271.884,2.863,1.894,5.687,3.091,9.243L293.867,336l4.7,1.721-1.014.913c.839,1.728,1.678,3.456,2.489,5.406-.028.222-.049.669-.409.782-1.363.166-2.366.219-4.316.321a38.4,38.4,0,0,1,4.713,4.089,11.05,11.05,0,0,1-.165,2.127c-2.7.833-2.416,1.91-.764,3.719a11.071,11.071,0,0,1-.263,2.452c-.549.227-.835.114-1.341-.281a7.271,7.271,0,0,0-1.544.076,9.1,9.1,0,0,1,1.142.988c2.56.752,6.787,1.879,6.915,1.524,1.829-5.053,5.259-1.785,8.317-1.88a4.59,4.59,0,0,0,1.342-2.481c-1.7-1.4-3.179-2.552-4.663-3.907a7.788,7.788,0,0,0-.066-.9,26.882,26.882,0,0,1-1.966-1.958c.011-1.154.013-1.923.022-2.873.008-.181.012-.544.465-.533,2.7.011,4.957.011,8.579.011-3.813-3.865-2.214-7.08-.53-10.358.7-.693,1.1-1.335,1.836-1.993,1.326-.554,2.31-1.091,2.144-1-6.036-5.194-12.334-9.942-17.828-15.488-9.329-9.418-18.321-19.187-27.112-29.112-4.156-4.692-7.532-10.077-11.236-15.166-4.763-6.544-10.3-6.9-16.276-2.123-3.443,2.747-8.062,4-12.1,6.032-1.828.92-3.935,1.751-5.193,3.234-2.359,2.782-4.432,4.332-7.087,1.006l-7.556,6.074c-.128-9.115.642-16.576,10.2-19.138,1.247-.334,2.362-1.163,3.591-1.362a4.341,4.341,0,0,1,.019,1.517c-1.123,1.747-2.119,3.178-3.95,5.81,2.931,0,4.841.563,6.115-.1a118.492,118.492,0,0,0,14.946-8.668c8.252-5.964,8.988-12.636,2.978-21.706a2.567,2.567,0,0,1,.083-1.4c.741-1.991,1.63-3.661,1.728-5.375.5-8.758.81-17.527,1.146-26.293a32.619,32.619,0,0,0-.131-5.486,3.216,3.216,0,0,0-1.5-2.083c-.429-.233-1.509.268-2.03.736-7.4,6.646-14.855,13.227-22.071,20.064-6.025,5.708-8.076,13.319-9.234,21.443a1.949,1.949,0,0,1-.161.914c-3.508,3.509-7.317,6.372-10.1,10.019-5.7,7.474-10.884,15.343-16.207,23.1-4.813,7.015-10.17,13.109-19.7,12.92-.462-.009-.931.319-1.687.123-.514-.584-.738-.8-.734-1.271,3.217-3.12,6.429-5.791,9.155-8.89,9.972-11.33,20.125-22.53,29.48-34.357,3.646-4.61,5.661-10.635,7.818-16.247,1.083-2.819.82-6.156,1.165-9.259l1.013.9c3.561-2.154,7.315-4.049,10.646-6.514,7.945-5.88,15.721-11.991,23.478-18.119a4.612,4.612,0,0,0,1.7-3.167c-.117-4.605-.14-9.291-1.07-13.765-.459-2.211-2.811-4.029-4.751-6.618-1.142-9.865,2.978-20.839-.466-31.917a9.832,9.832,0,0,1-2.67,1.576,10.979,10.979,0,0,1-1.783-2.137c5.218-5.135,11.632-4.248,16.006,1.464,2.879,3.76,6.309,7.1,9.47,10.641,2.5,2.8,5.012,5.595,7.438,8.461,5.794,6.846,11.442,13.818,17.345,20.568,3.215,3.676,7.009,6.847,10.214,10.53,3.856,4.432,7.3,9.216,11.053,13.745,1.378,1.664,3.4,2.83,4.624,4.579,3.175,4.543,6.952,7.82,12.769,8.376a7.632,7.632,0,0,1,4.591,2.154c7.549,8.388,14.911,16.945,22.653,25.728a26.593,26.593,0,0,1,.4,6.979c-5.059-6.2-9.8-12.283-14.541-18.366l-1.425,1.121,16.005,21.63c1.071-2.191,1.584-3.239,2.186-4.71.333-1.24.576-2.058,1.031-3.588,2.04,6.942,3.089,13.415,5.87,19.031,2.108,4.256.873,8.089,1.119,12.1.062,1.01-.819,2.067-1.148,3.14-.018.059,1.426.8,1.575.64.973-1.03,2.233-2.105,2.555-3.379,1.212-4.793,2.1-9.669,3.411-14.746.679-1.967,1.059-3.7,1.735-5.616,2.841-12.332,5.612-24.443,7.866-36.65,2.228-12.068,4.076-24.211,5.812-36.362,1.025-7.172,1.7-14.41,2.15-21.643.2-3.162-.37-6.351-4.9-6.515-20.109-.727-40.073-2.557-59.8-6.876-23.715-5.192-45.6-13.778-63.183-31.28-6.32-6.291-12.851-12.369-19.589-18.836a48.884,48.884,0,0,1-4.182,5.523c-6.55,6.618-12.884,13.518-19.977,19.51-6.57,5.55-13.5,11.127-21.165,14.835-17.007,8.223-35.405,12.23-54.143,14.155-13.663,1.4-27.4,2.171-41.119,2.906-3.674.2-5.17,1.418-4.812,5,.439,4.386.85,8.775,1.28,13.162.6,6.135.857,12.33,1.887,18.393,2.161,12.732,4.629,25.414,7.175,38.076,1.284,6.384,3.014,12.677,4.542,19.012a15.042,15.042,0,0,0,4.078-6.776c.738-2.845.9-5.84,1.651-8.77a13.254,13.254,0,0,1,3.255.264c.867,1.184,1.5,2.106,2.222,3.178a10.078,10.078,0,0,0,.8.855c.753,1.7,1.366,3.077,2.038,4.849,1.106,2.228,2.152,4.065,3.327,6.238,7.167,2.645-2.874,4.159,1.007,6.618.138,0,1.431,0,2.967.1a4.21,4.21,0,0,1,1.63,1.237c-1.654,2.7-3.328,5.05-5.089,7.52a44.042,44.042,0,0,1,5.2,2.607,7.6,7.6,0,0,1-.128,2c-5.527,2.84,3.753,2.013.364,4.165l-6,1.238c2.117,1.414,4.292,1.3,6.121,2.048,2.847,1.158,7.582,2.26,6.475,5.779-.972,3.092.7,4.4,1.161,6.183l-2.983,6.577,12.432,5.487c-1.787,4.562-4.918,3.468-7.369,2.652-3.4-1.132-5.763-.382-8.338,2.587l15.476,3.073-.223,1.459-5.118.685,6.031,3.936c-3.288,1.981-7.823,3.146-9.118,5.857-2,4.188-5.163,2.156-7.659,2.822,1.968-3.453,3.976-6.507,6.2-9.894.192.367.1.021-.123-.2a4.583,4.583,0,0,0-1.186-.885c-5.172-2.485-10.517-4.819-8.114-12.328.169-.529-.458-1.266-.448-1.9.051-3.491.4-6.992.206-10.465-.11-1.964-.469-4.876-1.75-5.65-5.995-3.621-7.34-8.858-7.086-15.3.056-1.433-1.782-3.648-3.27-4.289-3.344-1.439-7.016-2.116-10.6-3.492-.349-2.463-.652-4.537-.993-6.977-1.346-3.789-2.654-7.211-3.962-10.967,0-.778,0-1.222-.021-1.964-.34-.766-.66-1.234-.979-2.036,0-.778,0-1.222,0-2-.334-1.113-.666-1.887-1-3.037,0-1.125,0-1.875-.005-3-.668-2.124-1.332-3.877-1.995-5.963,0-.778,0-1.222,0-2.062-.666-1.8-1.333-3.2-2-4.6a6.224,6.224,0,0,1,.25-1.85A11.368,11.368,0,0,0,102,217M245.383,346.78c-.131-.248-.262-.5-1.224-.766-1.386,0-2.772-.009-4.762.057l-.988,1.216A13.139,13.139,0,0,1,240.4,348.4c1.2-.135,2.4-.27,4.017-.6A1.493,1.493,0,0,0,245,347a1.252,1.252,0,0,1,.384-.218m15.279,19.295a1.813,1.813,0,0,0,.685-.171,1.793,1.793,0,0,0-.685.171m10.3-105.679a2.5,2.5,0,0,1-.994-1,2.588,2.588,0,0,1-1.057-1.048,9.923,9.923,0,0,1-1.99-2.009,10.346,10.346,0,0,1-1.957-1.945,3.273,3.273,0,0,1-1.159-1.149,7.547,7.547,0,0,0-.134,1.787c.112.153.258.26.767.889.648.574,1.3,1.148,2.291,2.2a28.282,28.282,0,0,1,2.048,1.982,6.668,6.668,0,0,1,.906.934,9.231,9.231,0,0,1,.647.8,7.642,7.642,0,0,1,1.082,1.13c.654.91,1.307,1.819,2.255,3.227a9.854,9.854,0,0,1,1.39,2.591,17.584,17.584,0,0,1,2.056,6.052l-3.678.875a17.408,17.408,0,0,1,4.556,4.028c5.995,7.061,11.989,14.123,18.078,21.843.76.013,1.759.33,2.223-.034.667-.523.945-1.542,2.1-2.4,1.917,1.437,3.936,2.76,5.724,4.343a60.652,60.652,0,0,1,5.888,6.232l.774-.018c-.143-.354-.286-.707-.6-1.728-2.993-5.971-8.409-8.937-13.982-12.048-3.261-1.82-7.08-4.718-8.163-7.961-2.838-8.493-8.943-14.361-14.385-21.491a9.293,9.293,0,0,1-1.52-2.323,23.06,23.06,0,0,1-2.167-2.769,2.594,2.594,0,0,1-1-.991m14-7.871a3.8,3.8,0,0,1,1.041,1.335l18.274,26.367,1.59-1.06a98.712,98.712,0,0,1-5.9-9.794,52.213,52.213,0,0,0-3.68-4.689c-3.271-4.146-6.542-8.293-10.294-12.883-.346.1-.693.2-.779-.207a1.984,1.984,0,0,1-1.184-1.09,12.007,12.007,0,0,1-3.025-3.375c-.336-2.376-.672-4.752-1.086-7.834l-4.635-4.076c-.153,2.56-.22,3.671-.287,5.591A14.585,14.585,0,0,1,273.273,246a3.036,3.036,0,0,1-2.393-.847c-.659-3.3-1.317-6.6-1.918-10.665.167-1.44,1.02-3.417.385-4.229-3.276-4.186-6.933-8.074-11.11-12.806-1.884,6.367-1.829,11.741-.042,16.547a26.267,26.267,0,0,1,7.829.744c1.654,4.073,3.308,8.147,5.176,12.673a1.232,1.232,0,0,1,.583,1.1,7.037,7.037,0,0,0-.773,2.216,37.335,37.335,0,0,1,3.07,4.972c.97,1.286,1.888,2.616,2.92,3.851,4.315,5.163,8.664,10.3,13.072,16.157,4.019,9.352,7.255,12.53,11.79,11.2-2.645-4.346-5.253-8.631-7.933-13.616-4.31-6.767-8.62-13.533-12.8-21.02a8.558,8.558,0,0,1,3.2-.72,2.708,2.708,0,0,1,.641.965m-8.079-69.178-1.087.1c.225.349.45.7.855,1.418.158.23.349.426.971,1.195q6.127,14.675,12.246,29.354c.873,2.1,1.277,4.493,2.517,6.332,4.329,6.419,8.93,12.654,12.608,19.088-2.949-2.181-6.073-4.168-8.79-6.608-1.932-1.735-3.318-4.079-5.508-6.863-.357,9.705,6.121,13.746,11.369,19.323a53.255,53.255,0,0,0,4.8,5.609c9.452,8.443,16.63,18.277,20.109,30.672.621,2.212,2.645,4.03,4.359,6.5A6.355,6.355,0,0,0,334,287.1a47.434,47.434,0,0,0-.64-7.3c-1.275-5.311-2.886-10.542-3.6-15.8a14.971,14.971,0,0,1,3.429,2.765c3.7,5.185,8.37,9.979,5.864,17.348-.691,2.032-.629,4.32-.987,7.143-1.843,2.06-4.952,3.706-2.414,7.148,4.475,0,4.352-3.184,4.77-7a192.994,192.994,0,0,1,3.51-20.384l4.552.953a37.25,37.25,0,0,1,2.292-5.439,6.6,6.6,0,0,1,3.237-2.667c1.783,2.95-4.319,6.328.5,9.609,1.036-2.43,1.917-4.454,2.764-6.492,1.378-3.312.21-4.538-3.2-4.567,1.224-2.542.333-4.272-2.35-6.03a80.238,80.238,0,0,1-5.815-7.026A5.559,5.559,0,0,1,344,247.3a33.46,33.46,0,0,1-1-4.027A24.832,24.832,0,0,1,340,239.5s0-.5-.073-1.22c-2.309-3.427-4.618-6.853-7.008-11-3.64-2.095-7.279-4.189-11.216-6.892l-8.559-8.382-1.07,1.126c2.642,3.288,5.284,6.577,8,10.571,2.977,3.765,5.954,7.529,9.186,11.886a24.519,24.519,0,0,1,2.812,4.095,28.909,28.909,0,0,1,1.837,4.986,5.632,5.632,0,0,1-3.174.759,165.793,165.793,0,0,1-25.262-37.83l-4.2-9.237a10.6,10.6,0,0,1-2.925,2.58,9.139,9.139,0,0,1-3.331-1.585,2.739,2.739,0,0,1-.591-2.354c3.642-2.765,2.415-6.032-3.722-9.752a22.472,22.472,0,0,1-4.486,2.713,9.519,9.519,0,0,1-3.294-3.081c2.582-5.442,2.022-7.728-3.249-12.376a4.447,4.447,0,0,1-1.948-1.088,8.518,8.518,0,0,1-2.855-2.149c-4.489-1.344-7.265-4.632-9.711-8.372-.352-.539-1.417-.612-2.193-1.5a19.9,19.9,0,0,1-1.241-2.047c-.7-1.323-1.082-3.175-2.177-3.816-1.04-.609-3.7-.484-4.138.235-3.466,5.717-2.943,11.8-.131,17.521,2.31,4.7,8.666,7.1,12.586,4.413,3.1-2.118,5.956-1.933,9.183-1.116a8.074,8.074,0,0,1,1.063,2.09c2.322,1.821,2.97,4.071,1.176,6.572a2.64,2.64,0,0,1-1.308-.9,2.005,2.005,0,0,1-1.085-1.009m44.279,113.394a6.117,6.117,0,0,1,1.591-.676s.22.053.224.1a7.592,7.592,0,0,1-.854.71c-.116,3.74-.232,7.481-.532,12.028a40.4,40.4,0,0,1-1.431,9.134c-1.313,1.681-2.688,3.322-3.839,5.107-.109.169,1.193,1.246,2.283,1.882,0,0,.444-.011.552.65a33.558,33.558,0,0,1,5.063-2.441c-.11-1.09-.219-2.181-.4-3.873a2.817,2.817,0,0,1-.859-2.148,45.63,45.63,0,0,1,1.852-9.424,19.722,19.722,0,0,1,1.9-5.789,3.03,3.03,0,0,1,2.258.772c.674,1.74,1.348,3.48,2.273,5.8a22.225,22.225,0,0,1,1.061,2.371,16.964,16.964,0,0,1,1.173,4.241c-.217.158-.374.361-1.108.9,1.212,3.09,2.858,2.421,4.258.291.841-1.28,1.151-2.908,2.249-4.487-.01-.65-.019-1.3.072-2.594a6.21,6.21,0,0,1-.575-2.849l1.093-1.935c-.787-.183-1.574-.366-3.124-.759a6.926,6.926,0,0,1-2.594-.333,3.9,3.9,0,0,1-.892-1.173,26.621,26.621,0,0,0-1.293-4.077c-3.1-6.214-6.309-12.373-9.464-18.559-.95-1.863-1.678-3.862-2.8-5.609-7.46-11.58-16.757-21.582-26.728-31.012a16.517,16.517,0,0,1-3.873-5.04c-3.1-7.041-5.84-14.238-8.865-21.312-1.007-2.355-2.463-4.519-3.881-7.316l-.729-.1a10.434,10.434,0,0,0,.275,1.98l3.9,14.139-1.3.422-11.421-7.233-1.451,1.9A48.747,48.747,0,0,1,270,224c4.824,4.565,9.76,9.041,14.253,13.92,14.317,15.547,24.906,33.751,36.074,51.522.629,1,.116,2.721-.713,3.583-3.2-3.024-6.41-6.048-9.7-9.77l-2.974-2.245-.866,1.5a8.625,8.625,0,0,1,3.051,2.233c3.962,3.775,7.923,7.55,11.864,11.259,0,0-.066-.02.173.741m-59.949,39.221-3.446.4.551,1.65c1.262-.631,2.525-1.263,4.26-1.983l.778-.455a14.648,14.648,0,0,1-2.144.393m-110.207,5.61a12.4,12.4,0,0,1,2.971,3.222c.336,2.078.672,4.157,1.113,6.9a5.37,5.37,0,0,0,2.909-1.44,3.094,3.094,0,0,1,.808-2.249l2.018-1.862a6.662,6.662,0,0,1-3.081-.85l-2.035-6.658a5.841,5.841,0,0,1-2.2,1.321c-.167-.025-.334-.049-.585-.712l-1.966-2.033-.67.637a33.7,33.7,0,0,1,.719,3.723m183.4-1.516a16.787,16.787,0,0,0-.539,2.583l.454,2.4,4.161-5.051c-1.554,0-2.53,0-4.076.064m-.216-15.167c.9,2.512-3.812,6.109,1.6,7.665,3.3-3.345,3.116-5.727-.531-9.19l-.241-1.937a16.1,16.1,0,0,0-.831,3.462m-132,70.854-4.086,9.679,4.848,2.43c.788-3.945,1.682-8.421,2.838-13.621-.886-4.354-.321-8.294,3.525-10.6l3.131,33.141c5.364-3.627,6.927-9.5,7.018-16.213l3.509-2.183a7.955,7.955,0,0,1-2.993-1.7s.017-.483.733-.773a70.829,70.829,0,0,1,2.1-11.931c.235-.023.47-.045,1.257.419.636.047,1.822.18,1.831.128.461-2.929.824-5.874,1.166-8.574-3.67,0-7.031.781-9.805-.162-5.805-1.975-8.572,1.45-12.345,5.444h-7.077c.418,1.987.806,3.831,1.227,6.293a7.367,7.367,0,0,1,1.787,2.21c.453,1.75.905,3.5,1.338,6.016m147.436-91.826,5.578-6.954-1.272-.162-.237-5.414-1.926-.444,4.915-12.914c-2.529.455-7.421-2.029-4.678,4.383.33.772-2.241,2.786-4,4.852l-1.707-5.035a11.6,11.6,0,0,0-.206,6.44c.829,3.465,1.93,6.864,2.908,10.861a2.789,2.789,0,0,1-.178,1.081,6.368,6.368,0,0,1-.6,3.34c-2.953.8-3.162,2.162-.313,6.487a22.343,22.343,0,0,1,1.719-6.52M213.926,347.742a4.1,4.1,0,0,1,.62-2.124l1.823-2.579c-5.358-1.478-8.459.52-10.467,4.7l4,4.836-10.239,4.282,9.167,2.384-4.086,2.3,11.185,3.249,1.317-1.408c-6.123-.763-1.49-3.412-1.638-4.571l-5.352-3.835a29.847,29.847,0,0,0,4.067-3.776c.361-.488-.3-1.734-.4-3.451m58.26,54.214,2.1,6.138-3.241,2.954c5.295-.257,8.577-3.883,7.5-6.8-1.887-5.116-1.69-9.757,1.892-14.224,1.173-1.462,1.345-3.726,1.979-5.634H269.565a61.16,61.16,0,0,0,.528,6.154c.52,2.782,1.306,5.514,1.927,9.019a17.89,17.89,0,0,0,.166,2.393m-78.242-15.211,1.179-7.845c-7.449.82-15.319-3.349-20.605,4.947l10.872,1.692c-3.956,4.55-3.229,8.424,2.5,12.18,1.774-2.871,3.589-5.809,5.756-9.153.062-.348.124-.7.3-1.821m67.03,12.734a3.578,3.578,0,0,1,.214-1.413l5.269-14.7-7.557-1.514c1.064-3.567-1.264-5.163-7.308-5.391.816,3.523,1.613,6.96,2.412,11.178a12.644,12.644,0,0,1-.118,2.467c.327,5.968.654,11.935.689,18.026-.277.243-.288.507-.2,1.523a1.99,1.99,0,0,1,.1,1.727,5.855,5.855,0,0,0-.112,2.446l4.343,2.114a33.352,33.352,0,0,1,1.314-3.9A43.771,43.771,0,0,1,262.4,408.1l-2.724-3.177,3.162-2.638a7.951,7.951,0,0,1-1.859-2.808m-17.863,6.508c3.079-3.012-.159-4.03-1.682-5.153a12.257,12.257,0,0,0,2.581-2.678c0-.343,0-.686.632-1.521l3.7-20.4a25.859,25.859,0,0,1-6.435-1.8,12.216,12.216,0,0,1-3.044-2.177c-1.047.5-2.334.78-3.086,1.566a24.719,24.719,0,0,0-2.993,4.692,13.1,13.1,0,0,0-.59,3.263c.575,2.479,1.545,4.945,1.62,7.439.085,2.847-.7,5.711-.963,8.581-.12,1.3.694,3.167.069,3.857-2.422,2.672-.757,4.464.544,6.773a14.65,14.65,0,0,1,1.41,5.923c.324,4.122-3.323,8.652,1.425,12.274l5.175-2.616c-.293-1.461-.992-2.886-.738-4.114.543-2.622,3.528-4.935.363-7.925-.476-.449.67-2.614,1.461-4.31.11-.317.219-.635.551-1.677m23.116-220.469-3.475-2.539c-3.31,5.7-2.488,9.423,2.962,11.661,1.823.749,4.459-.483,6.723-.81-.393-1.99-.354-4.235-1.328-5.881-.671-1.134-2.745-1.439-4.882-2.431M247.28,355.057l-5.963,1.63c-.624,6.962-.388,7.253,6.751,8.806,1.033-1.854,1.99-3.692,3.064-5.459.748-1.231,1.658-2.363,2.495-3.54a41.3,41.3,0,0,0-6.346-1.438m64.361,42.486-10.206-7.552v9.495c3.333-.531,6.466-1.031,10.206-1.943M181.7,374.745c-3.655-6.006-4.791-6.328-8.425-2.61a29.294,29.294,0,0,0,4.685,3.295,4.212,4.212,0,0,0,3.74-.684m18.922-49.384,4.942-4.691-1.083-1.815-7.422.6c1.515,2.678,2.3,4.074,3.563,5.906m-77.871-67.969c-.262-.655-.582-1.894-.779-1.875-2.342.228-3.911,4.971-2.152,7.837.965-1.938,1.8-3.614,2.931-5.962m118.261,80.515,2.2-2.787-1.474-.99-3.788,2.973c1.235.31,1.856.466,3.066.8m44.133-124.771-1.947-2.963-1.394.874,2.462,4.4a4.351,4.351,0,0,0,.879-2.311m23.614,102.639,1.764-1.368-2.382-1.2a4.581,4.581,0,0,0,.618,2.563m-63.248,12.571,3.6.607.047-1.581a7.426,7.426,0,0,0-3.646.974m41.778-107.913L287,223.451l1.7-.129a11.862,11.862,0,0,0-1.417-2.889M186.937,339.171l-1.5.792a7.761,7.761,0,0,0,.525.639,1.8,1.8,0,0,0,.973-1.431m12.345-3.462.924-1.274-1.256-.216a1.545,1.545,0,0,0,.331,1.49m58.978-87.54,1.226.162-.588-1.574a2.2,2.2,0,0,0-.638,1.412m19.42,124.218,1.986-1.232-.426-.674a4.122,4.122,0,0,0-1.56,1.906m-15.442-17.771-1.693-.874-.24.744a3.96,3.96,0,0,0,1.934.13m8.885,63.5.687,1.565.653-.349a2.274,2.274,0,0,0-1.34-1.216m-13.095-72.294,1.23-.29c-.09-.122-.2-.357-.267-.348-.416.058-.825.173-.963.637m14.657-138.871.715.432.264-.737c-.354-.041-.707-.082-.979.3m64.272,143.364.435-.721-.743-.266c-.041.357-.082.713.308.987m-55.133,30.925.167.5a.354.354,0,0,0-.167-.5m63.352-102.487-.168-.505a.355.355,0,0,0,.168.505m-63.94,92.424.518-.172a.363.363,0,0,0-.518.172M265.178,217.765l-.172-.517a.364.364,0,0,0,.172.517m52.58,127.058-.507.168a.356.356,0,0,0,.507-.168m-130.282.554.165-.644a.547.547,0,0,0-.165.644m73.113-1.859h0m-4.991,0h0m77.92-5.116h0m-133.11-6.92h0m55.991,35Z"
                    fill="#040505"
                />
                <path
                    id="Path_61785"
                    data-name="Path 61785"
                    d="M260.351,510.378c-3.249,3.574-6.15,7.015-9.411,10.071-2.955,2.768-6.091,2.2-8.7-.755-9.873-11.152-19.967-22.124-29.465-33.589-6.773-8.177-12.656-17.086-19.077-25.562-2.5-3.3-5.562-6.163-8.037-9.473-2.547-3.407-4.591-7.185-7.036-10.674-2.273-3.243-4.9-6.24-7.144-9.5a45.281,45.281,0,0,1-2.921-5.837c6.458-3.145,7.228,2.448,8.439,4.848,3.888,7.706,9.6,10.942,18.054,10.143,3.953-.374,7.905-.839,8.847,5.125.334,2.112,3.541,3.722,5.33,5.66,8.258,8.942,17.7,15.608,29.937,18.411,5.89,1.349,11.279,4.885,17.2,7.568,2.1-2.8,5.032-5.384,6.155-8.6,1.106-3.167,2.771-4.368,5.579-5.482,2.215-.879,3.99-2.851,5.988-4.3,1.713-1.24,3.345-3.19,5.224-3.485,4.8-.754,6.158-3.95,7.731-7.853,1.065-2.642,3.871-4.54,5.694-6.927,2.933-3.84,5.623-7.865,8.565-11.7a19.352,19.352,0,0,1,4.7-4.854c3.777-2.339,6.573-4.861,6.146-9.862-.1-1.143,1.552-2.435,2.4-3.658a24.5,24.5,0,0,1,3.264,3.067c.546.723.223,2.109.776,2.818,3.272,4.2,2.6,6.588-2.468,8.948-2.079.967-3.349,4.855-3.921,7.634a25.685,25.685,0,0,1-7.726,13.964c-2.231,2.137-3.239,5.539-4.841,8.347-3.16,5.538-9.382,9.142-9.608,16.67-.069,2.3-2.93,4.568-4.633,6.757C277.128,488.907,268.828,499.486,260.351,510.378Z"
                    fill="#070707"
                />
                <path
                    id="Path_61786"
                    data-name="Path 61786"
                    d="M112,258c.3,2.074.606,4.148.995,6.976.505,1.456,1.138,2.11,1.3,2.867.5,2.272,1.661,4.936.9,6.755-.5,1.205-3.864,1.2-5.933,1.786a5.069,5.069,0,0,0-1.142.685c2.973,4.187,6.795,5.393,7.5,2.611,1.2-4.741,4.749-3.575,8.259-4.677-.221,5.433-.248,10.525,5.623,12.737.4.15.335,1.519.49,2.321.524,2.725.863,5.5,1.615,8.163,1.251,4.429.084,6.847-4.132,8.548a68.967,68.967,0,0,0-6.42,3.344c1.561,5.2,4.6,5.931,8.7,6.042,4.054.11,8.074,1.51,12.821,2.492C134.269,327.7,134.115,331.8,141,335c.323.1.585.288.891,1.192.167,3.561-.636,6.915.534,9.3,1.149,2.346,4.3,3.71,6.576,5.506a35.239,35.239,0,0,0,1.732,3.811c1.684,3.426,3.1,6.662,4.643,10.187-6.062,6-2.681,13.935-3.114,21.277a1,1,0,0,0,.152.472q1.8,3.474,3.615,6.942l6.95-5.275c2.69,1.289,7.653-2.1,10.457,2.778.688,1.2,1.044,2.586,1.76,3.76.887,1.453,2,2.767,3,4.155,1.091,1.522,2.158,3.061,2.838,4.029-4.333,2.522-8.637,3.767-10.763,6.63-2.011,2.707-1.736,7.113-2.591,11.394a12.385,12.385,0,0,1-2.633-2.2c-5.943-8.706-12.1-17.287-17.595-26.273a274.681,274.681,0,0,1-14.51-26.506c-4.808-10.253-8.634-20.964-12.977-31.439-3.281-7.914-7.031-15.649-9.975-23.682-3.328-9.082-5.932-18.427-8.956-27.622-3.592-10.922-7.3-21.806-10.993-33.073.379-.632,1.056-.813,1.175-1.176,1.622-4.946,3.993-8.554,10.156-6.427a5.872,5.872,0,0,0,1.536-3.006c.093-2.41-.281-4.839.074-7.307A13.549,13.549,0,0,1,106,235a12.941,12.941,0,0,1-.255,2.824A8.677,8.677,0,0,0,107,241a6.66,6.66,0,0,1-.229,1.838A4.643,4.643,0,0,0,108,245a6.184,6.184,0,0,1-.277,1.913C106.539,252.046,108.248,255.466,112,258Z"
                    fill="#070707"
                />
                <path
                    id="Path_61787"
                    data-name="Path 61787"
                    d="M366,335c-1.568,1.469-3.136,2.939-5.174,4.748-1.589,1.31-2.708,2.281-3.826,3.252h-2.051c-5.747.246-3.027-2.966-2.949-5-.256-3.923-1.448-8.1-.483-11.691a13.952,13.952,0,0,1,6.472-7.825c2.981-1.552,7.078-1.611,10.579-1.253,1.9.194,3.576,2.613,5.037,4.436-1.745,2.717-3.176,5.025-4.606,7.333a3.866,3.866,0,0,1-.337,1.715C367.55,332.4,366.775,333.7,366,335Z"
                    fill="#070707"
                />
                <path
                    id="Path_61788"
                    data-name="Path 61788"
                    d="M337,358c1.639-.8,3.892-1.173,4.8-2.48,2.414-3.481,5.252-2.854,8.267-1.581,3.5,1.48,1.5,4.047.735,6.838A20.837,20.837,0,0,0,350,363c-.333,1.418-.666,2.836-1.285,4.874-1.059,4.224-1.561,7.915-2.687,11.405a45.789,45.789,0,0,1-4.368,8.755A22.94,22.94,0,0,0,339,391a30.853,30.853,0,0,1-5.814.7c-1.105-1.92-2.509-4.272-1.9-5.036,2.092-2.647,4.55-5.4,7.487-6.891,4.256-2.167,5.651-6.566,2.231-9.776a34.457,34.457,0,0,1-4.889-4.054c-.734-2.031-1.284-3.4-1.808-4.712Z"
                    fill="#070707"
                />
                <path
                    id="Path_61789"
                    data-name="Path 61789"
                    d="M363.671,289.168c5.161,3.324,8.4.076,12.018-3.015,1.446-.7,2.58-1.238,4.843-2.321,0,3.013.845,6.021-.293,7.618-.776,1.09-4.32.209-6.88.209,4.035,8.211,2.967,11.908-4.979,17.331-2.569-3.718-5.117-7.29-6.825-11.226C360.323,294.925,360.12,291.581,363.671,289.168Z"
                    fill="#070707"
                />
                <path
                    id="Path_61790"
                    data-name="Path 61790"
                    d="M193.39,415.1a12.736,12.736,0,0,1,3.338-.16c2.019.44,3.987,1.112,5.975,1.689-1.259,2.127-2.071,4.949-3.93,6.146-1.317.848-4.841.2-5.946-1.045C191.471,420.2,189.295,417.218,193.39,415.1Z"
                    fill="#070707"
                />
                <path
                    id="Path_61791"
                    data-name="Path 61791"
                    d="M340.993,370.394c3.427,2.816,2.032,7.215-2.224,9.382-2.937,1.5-5.395,4.244-7.487,6.891-.6.764.8,3.116,1.5,5.036-1.051-.005-3.362-.185-3.415-.63-.272-2.308-.9-5.819.319-6.813,3.079-2.519,4.441-7.176,9.395-7.73C339.92,376.437,340.361,372.792,340.993,370.394Z"
                    fill="#070707"
                />
                <path
                    id="Path_61792"
                    data-name="Path 61792"
                    d="M342.348,387.945c1.021-2.843,2.7-5.641,3.679-8.666,1.126-3.49,1.629-7.181,2.687-11.032.192,4.523,1.741,9.509-2.1,13.731C345.045,383.708,343.988,385.906,342.348,387.945Z"
                    fill="#070707"
                />
                <path
                    id="Path_61793"
                    data-name="Path 61793"
                    d="M336.592,358a15.29,15.29,0,0,1-2.288,3.234c.524,1.307,1.074,2.681,1.661,4.41-2-1.328-4.036-3.012-7.372-5.772C331.981,359.036,334.082,358.518,336.592,358Z"
                    fill="#070707"
                />
                <path
                    id="Path_61794"
                    data-name="Path 61794"
                    d="M276.272,424.2a7.988,7.988,0,0,1,.6-2.9c4.839.317,5.436,2.021,2.155,6.648C278.144,426.677,277.344,425.535,276.272,424.2Z"
                    fill="#070707"
                />
                <path
                    id="Path_61795"
                    data-name="Path 61795"
                    d="M351.625,338.047c.3,1.985-2.423,5.2,2.99,4.951-.8,4.019-3.708,1.371-4.586.545C348.04,341.676,348.452,339.392,351.625,338.047Z"
                    fill="#070707"
                />
                <path
                    id="Path_61796"
                    data-name="Path 61796"
                    d="M369.341,328.95a40.669,40.669,0,0,1,4.3-6.912A40.666,40.666,0,0,1,369.341,328.95Z"
                    fill="#070707"
                />
                <path
                    id="Path_61797"
                    data-name="Path 61797"
                    d="M298.763,472.7c-.413,2.08-1.084,4.312-1.758,6.924a4.558,4.558,0,0,1-2.839-.431A47.2,47.2,0,0,1,298.763,472.7Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_61798"
                    data-name="Path 61798"
                    d="M319.288,405.512a9.855,9.855,0,0,1,2.109,2.343l-2.6.823A12.72,12.72,0,0,1,319.288,405.512Z"
                    fill="#070707"
                />
                <path
                    id="Path_61799"
                    data-name="Path 61799"
                    d="M357.207,343.259a14.509,14.509,0,0,1,3.471-3.215A14.509,14.509,0,0,1,357.207,343.259Z"
                    fill="#070707"
                />
                <path
                    id="Path_61800"
                    data-name="Path 61800"
                    d="M346.159,346.748a6.132,6.132,0,0,1-.249-2.436l1.7.451A6.348,6.348,0,0,1,346.159,346.748Z"
                    fill="#070707"
                />
                <path
                    id="Path_61801"
                    data-name="Path 61801"
                    d="M366.337,334.952a13.008,13.008,0,0,1,2.325-3.9A13.008,13.008,0,0,1,366.337,334.952Z"
                    fill="#070707"
                />
                <path
                    id="Path_61802"
                    data-name="Path 61802"
                    d="M339.34,390.966a9.488,9.488,0,0,1,2.319-2.932A9.488,9.488,0,0,1,339.34,390.966Z"
                    fill="#070707"
                />
                <path
                    id="Path_61803"
                    data-name="Path 61803"
                    d="M325.8,355.2a3.846,3.846,0,0,1-1.217,1.208l-.345-1.343A2.846,2.846,0,0,1,325.8,355.2Z"
                    fill="#070707"
                />
                <path
                    id="Path_61804"
                    data-name="Path 61804"
                    d="M319.162,382l2.484,0a2.379,2.379,0,0,1,.353,1.669,3.372,3.372,0,0,1-2.733-.587A2.474,2.474,0,0,1,319.162,382Z"
                    fill="#070707"
                />
                <path
                    id="Path_61805"
                    data-name="Path 61805"
                    d="M350.293,362.97a2.491,2.491,0,0,1,.461-1.8A2.491,2.491,0,0,1,350.293,362.97Z"
                    fill="#070707"
                />
                <path
                    id="Path_61806"
                    data-name="Path 61806"
                    d="M87.021,240.3a2.854,2.854,0,0,1,1.208,1.531A2.854,2.854,0,0,1,87.021,240.3Z"
                    fill="#070707"
                />
                <path
                    id="Path_61807"
                    data-name="Path 61807"
                    d="M386,251c.3-2.074.606-4.148.954-6.611a34.35,34.35,0,0,1,4.607-3.484c.443,1.226,1.214,2.307,1.14,3.327-.447,6.107-2.322,12.121.023,18.359.478,1.271-1.376,3.844-2.729,5.273-1.872,1.977-4.288,3.438-7.467,5.887.514-3.512.985-6.732,1.464-10.351a36.118,36.118,0,0,1,.358-6.027C385.134,254.926,385.567,252.963,386,251Z"
                    fill="#070707"
                />
                <path
                    id="Path_61808"
                    data-name="Path 61808"
                    d="M224,121c-7.1,5.642-14.194,11.284-21.61,16.6a19.743,19.743,0,0,1-.322-4.026c-.033-2.462-1.072-6.307.064-7.119,3.089-2.208,7.1-3.133,10.833-4.6l2.014,4.111,2.022,1.59L219,123c.587-.489,1.174-.978,2.255-1.733A11.465,11.465,0,0,1,224,121Z"
                    fill="#050506"
                />
                <path
                    id="Path_61809"
                    data-name="Path 61809"
                    d="M218.682,122.86a23.993,23.993,0,0,1-1.68,4.695l-2.022-1.59-2.014-4.111c-3.738,1.471-7.745,2.4-10.833,4.6-1.136.812-.1,4.657-.064,7.119.017,1.234,0,2.468-.032,4.063a14.4,14.4,0,0,1-4.916,3.062,23.976,23.976,0,0,0-5.144.821c-3,.8-5.985,1.648-8.976,2.477,3.788-1.989,7.442-4.325,11.407-5.859,3.241-1.254,5.164-2.808,4.587-6.445-.788-4.974.669-8.416,6.116-9.3a4.424,4.424,0,0,0,1.779-.856C211.081,118.483,214.939,118.437,218.682,122.86Z"
                    fill="#070707"
                />
                <path
                    id="Path_61810"
                    data-name="Path 61810"
                    d="M291.742,116.223c7.721,3.672,15.167,7.578,22.935,11.636-.12,4.513-1.974,3.541-4.492,1.62a7.151,7.151,0,0,0-4.342-1.5C300.507,128.3,291.216,121.036,291.742,116.223Z"
                    fill="#070707"
                />
                <path
                    id="Path_61811"
                    data-name="Path 61811"
                    d="M263.768,89.184c5.145,4.949,10.04,10.092,15.077,15.538-1.318.314-3.563.938-4.109.238C270.8,99.917,267.216,94.6,263.768,89.184Z"
                    fill="#070707"
                />
                <path
                    id="Path_61812"
                    data-name="Path 61812"
                    d="M182.189,126.252c3.25-2.184,6.708-4.084,10.484-6.125,2.208,3.534-1.582,4.31-3.128,5.877C187.668,127.907,184.959,128.84,182.189,126.252Z"
                    fill="#070707"
                />
                <path
                    id="Path_61813"
                    data-name="Path 61813"
                    d="M368.013,138.448c3.69-.071,7.391.238,11.539.555.929,3.429-.9,4.8-3.837,3.84C373,141.959,370.576,140.2,368.013,138.448Z"
                    fill="#070707"
                />
                <path
                    id="Path_61814"
                    data-name="Path 61814"
                    d="M224.3,120.854a19.253,19.253,0,0,1-2.926.146c1.847-4.353,4.538-8.173,10.242-9A101.441,101.441,0,0,1,224.3,120.854Z"
                    fill="#070707"
                />
                <path
                    id="Path_61815"
                    data-name="Path 61815"
                    d="M172,149a41.653,41.653,0,0,1-6.636,1.629A3.161,3.161,0,0,1,165,149c5.712-1.667,11.423-3.333,17.461-4.741A2.9,2.9,0,0,1,182,146a3.387,3.387,0,0,1-1.937.707A60.411,60.411,0,0,0,172,149Z"
                    fill="#070707"
                />
                <path
                    id="Path_61816"
                    data-name="Path 61816"
                    d="M127.731,154.713c-4.753.62-9.776.953-15.265,1.287-.466-.444-.466-.889-.016-1.667A77.273,77.273,0,0,1,121,154,59.469,59.469,0,0,1,127.731,154.713Z"
                    fill="#050506"
                />
                <path
                    id="Path_61817"
                    data-name="Path 61817"
                    d="M392.077,140.3a92.857,92.857,0,0,1,10.514.666c-1.26,1-3,2.787-4.574,2.65C395.984,143.44,394.085,141.722,392.077,140.3Z"
                    fill="#070707"
                />
                <path
                    id="Path_61818"
                    data-name="Path 61818"
                    d="M241.911,74.656c2.071-.8,3.92-1.7,5.768-1.7.856,0,1.712,1.765,2.374,2.511-3.054.457-5.359.84-7.679,1.072C242.2,76.553,241.919,75.485,241.911,74.656Z"
                    fill="#070707"
                />
                <path
                    id="Path_61819"
                    data-name="Path 61819"
                    d="M317.951,129.35a22.626,22.626,0,0,1,4.741,1.514,7.732,7.732,0,0,1-2.488,3.211c-.653.4-1.92-.187-2.91-.331C317.5,132.387,317.7,131.03,317.951,129.35Z"
                    fill="#070707"
                />
                <path
                    id="Path_61820"
                    data-name="Path 61820"
                    d="M242,102a14.519,14.519,0,0,1-2.1.933A39.671,39.671,0,0,0,236,109h-3c1.345-4.087,2.291-8.582,8.6-7.75A.945.945,0,0,1,242,102Z"
                    fill="#070707"
                />
                <path
                    id="Path_61821"
                    data-name="Path 61821"
                    d="M120.936,153.644a63.768,63.768,0,0,1-8.486.356,14.611,14.611,0,0,1,1.259-4.406A76.879,76.879,0,0,1,120.936,153.644Z"
                    fill="#070707"
                />
                <path
                    id="Path_61822"
                    data-name="Path 61822"
                    d="M156.616,151a92.887,92.887,0,0,1-10.393,3.256A92.89,92.89,0,0,1,156.616,151Z"
                    fill="#050506"
                />
                <path
                    id="Path_61823"
                    data-name="Path 61823"
                    d="M242.416,102c-.416,0-.416-.5-.416-.75,2.406-2.892,5.58-2.4,7.99,1.363A54.785,54.785,0,0,1,242.416,102Z"
                    fill="#050506"
                />
                <path
                    id="Path_61824"
                    data-name="Path 61824"
                    d="M167.152,132.214A35.5,35.5,0,0,1,173.623,129C172.814,132.125,171.663,135.321,167.152,132.214Z"
                    fill="#070707"
                />
                <path
                    id="Path_61825"
                    data-name="Path 61825"
                    d="M274.348,123.034a18.043,18.043,0,0,1-.139-4.322l.931-.474,3.787,5.433C276.7,123.353,275.7,123.21,274.348,123.034Z"
                    fill="#070707"
                />
                <path
                    id="Path_61826"
                    data-name="Path 61826"
                    d="M95.719,167.238a29.594,29.594,0,0,1-.053,7.354A3.055,3.055,0,0,1,94,175C94.48,172.492,94.96,169.985,95.719,167.238Z"
                    fill="#050506"
                />
                <path
                    id="Path_61827"
                    data-name="Path 61827"
                    d="M93.749,175.213A5.651,5.651,0,0,1,95.666,175a21.5,21.5,0,0,1,1.3,4.7C93.631,180.161,93.521,177.827,93.749,175.213Z"
                    fill="#070707"
                />
                <path
                    id="Path_61828"
                    data-name="Path 61828"
                    d="M401.559,186.414a12.992,12.992,0,0,1-.244-2.936l1.344-.866,2.755,2.673-.939,1.377A12.565,12.565,0,0,1,401.559,186.414Z"
                    fill="#070707"
                />
                <path
                    id="Path_61829"
                    data-name="Path 61829"
                    d="M160.065,133.369a16.731,16.731,0,0,1,4.563-1.384C164.266,135.054,162.833,136.172,160.065,133.369Z"
                    fill="#070707"
                />
                <path
                    id="Path_61830"
                    data-name="Path 61830"
                    d="M105.995,234.63a17.486,17.486,0,0,1-2.735-2.428,5.3,5.3,0,0,1-.01-2.826A.973.973,0,0,1,104,229C104.663,230.753,105.327,232.506,105.995,234.63Z"
                    fill="#050506"
                />
                <path
                    id="Path_61831"
                    data-name="Path 61831"
                    d="M226.046,98.6c-.828-4.535,1.845-1.825,3.045-2.469l.508,1.139A27.292,27.292,0,0,1,226.046,98.6Z"
                    fill="#070707"
                />
                <path
                    id="Path_61832"
                    data-name="Path 61832"
                    d="M405.526,191.23a25.212,25.212,0,0,1-4.032,1.519l-.372-1.815A21.613,21.613,0,0,1,405.526,191.23Z"
                    fill="#070707"
                />
                <path
                    id="Path_61833"
                    data-name="Path 61833"
                    d="M163,151h-2.625a3.968,3.968,0,0,1,2.411-1.928A8.062,8.062,0,0,1,163,151Z"
                    fill="#070707"
                />
                <path
                    id="Path_61834"
                    data-name="Path 61834"
                    d="M102,222.4a13,13,0,0,1,1.74,4.1A3.183,3.183,0,0,1,102,226C102,224.933,102,223.867,102,222.4Z"
                    fill="#050506"
                />
                <path
                    id="Path_61835"
                    data-name="Path 61835"
                    d="M411.813,148.15a6.567,6.567,0,0,1,2.221,2.5A6.566,6.566,0,0,1,411.813,148.15Z"
                    fill="#070707"
                />
                <path
                    id="Path_61836"
                    data-name="Path 61836"
                    d="M393.025,225.527a9.035,9.035,0,0,1,.752,2.826l-1.39.065A9.115,9.115,0,0,1,393.025,225.527Z"
                    fill="#070707"
                />
                <path
                    id="Path_61837"
                    data-name="Path 61837"
                    d="M336.008,134.407a5.9,5.9,0,0,1,2.7.486,5.956,5.956,0,0,1-1.332,1.951A15.435,15.435,0,0,1,336.008,134.407Z"
                    fill="#070707"
                />
                <path
                    id="Path_61838"
                    data-name="Path 61838"
                    d="M304.508,137.335a3.97,3.97,0,0,1-1.2-1.465l.837-.383A4.662,4.662,0,0,1,304.508,137.335Z"
                    fill="#070707"
                />
                <path
                    id="Path_61839"
                    data-name="Path 61839"
                    d="M391.8,236.809a2.856,2.856,0,0,1-1.563.138l.342-1.348A3.882,3.882,0,0,1,391.8,236.809Z"
                    fill="#070707"
                />
                <path
                    id="Path_61840"
                    data-name="Path 61840"
                    d="M101.75,217.183a4.362,4.362,0,0,1,.5,2.634A4.362,4.362,0,0,1,101.75,217.183Z"
                    fill="#050506"
                />
                <path
                    id="Path_61841"
                    data-name="Path 61841"
                    d="M143.19,137.243a5.4,5.4,0,0,1,2.471-1.229A5.4,5.4,0,0,1,143.19,137.243Z"
                    fill="#070707"
                />
                <path
                    id="Path_61842"
                    data-name="Path 61842"
                    d="M102,226.338a3.209,3.209,0,0,1,1.739.555,3.737,3.737,0,0,1,.259,1.773c0,.333-.5.333-.75.333A7.871,7.871,0,0,1,102,226.338Z"
                    fill="#070707"
                />
                <path
                    id="Path_61843"
                    data-name="Path 61843"
                    d="M233,109.333a6.193,6.193,0,0,1,2.624-.334,7.034,7.034,0,0,1-2.3,1.974A2.458,2.458,0,0,1,233,109.333Z"
                    fill="#050506"
                />
                <path
                    id="Path_61844"
                    data-name="Path 61844"
                    d="M163.334,151a2.5,2.5,0,0,1-.334-1.667,2.5,2.5,0,0,1,1.667-.333,2.5,2.5,0,0,1,.334,1.666A2.5,2.5,0,0,1,163.334,151Z"
                    fill="#050506"
                />
                <path
                    id="Path_61845"
                    data-name="Path 61845"
                    d="M273.607,112.046a1.852,1.852,0,0,1-1.185.21c-.011,0,0-.307,0-.471A2.056,2.056,0,0,1,273.607,112.046Z"
                    fill="#070707"
                />
                <path
                    id="Path_61846"
                    data-name="Path 61846"
                    d="M405.534,237.392a1.88,1.88,0,0,1,.7-.981c.008-.007.213.221.326.339A2.081,2.081,0,0,1,405.534,237.392Z"
                    fill="#070707"
                />
                <path
                    id="Path_61847"
                    data-name="Path 61847"
                    d="M397.534,198.392a1.88,1.88,0,0,1,.7-.981c.008-.007.213.221.326.339A2.081,2.081,0,0,1,397.534,198.392Z"
                    fill="#070707"
                />
                <path
                    id="Path_61848"
                    data-name="Path 61848"
                    d="M408.738,192.046a2.479,2.479,0,0,1,.269,1.623,2.743,2.743,0,0,1-1.568-.384A5.723,5.723,0,0,1,408.738,192.046Z"
                    fill="#070707"
                />
                <path
                    id="Path_61849"
                    data-name="Path 61849"
                    d="M124.038,139.3a2.539,2.539,0,0,1,1.629-.306,2.7,2.7,0,0,1-.365,1.561A5.691,5.691,0,0,1,124.038,139.3Z"
                    fill="#070707"
                />
                <path
                    id="Path_61850"
                    data-name="Path 61850"
                    d="M120.3,239a78.4,78.4,0,0,1-1.315,8.769,15.042,15.042,0,0,1-4.078,6.776c-1.528-6.334-3.258-12.628-4.542-19.012-2.546-12.662-5.014-25.345-7.175-38.076-1.029-6.063-1.285-12.257-1.887-18.393-.43-4.387-.841-8.776-1.28-13.162-.358-3.579,1.139-4.8,4.812-5,13.72-.734,27.456-1.5,41.119-2.906,18.738-1.925,37.136-5.932,54.143-14.155,7.668-3.708,14.6-9.285,21.165-14.835,7.093-5.992,13.427-12.892,19.977-19.51a48.884,48.884,0,0,0,4.182-5.523c6.738,6.467,13.27,12.545,19.589,18.836,17.581,17.5,39.468,26.088,63.183,31.28,19.728,4.319,39.692,6.149,59.8,6.876,4.526.164,5.094,3.353,4.9,6.515-.453,7.232-1.125,14.47-2.15,21.643-1.736,12.15-3.584,24.294-5.812,36.362-2.253,12.207-5.025,24.318-8.083,36.464-4.295-4.666-8.076-9.325-11.873-14.349-1.55-2.644-.326-7.378-4.737-6.759-1.053.148-1.53,4.41-2.271,6.78-7.421-8.5-14.783-17.061-22.332-25.449a7.632,7.632,0,0,0-4.591-2.154c-5.817-.557-9.594-3.833-12.769-8.376-1.222-1.748-3.247-2.915-4.624-4.579-3.749-4.529-7.2-9.313-11.053-13.745-3.205-3.684-7-6.854-10.214-10.53-5.9-6.75-11.551-13.722-17.345-20.568-2.426-2.866-4.938-5.658-7.438-8.461-3.162-3.545-6.591-6.881-9.47-10.641-4.374-5.712-10.788-6.6-16.322-1.353-2.08,2.1-3.775,3.694-5.317,5.423-6.028,6.759-11.9,13.665-18.038,20.318-5.5,5.958-11.282,11.656-16.94,17.468l-1.29-1.036a25.759,25.759,0,0,1,2.252-4.709,5.526,5.526,0,0,0,1.477-.522c-.655-.178-1.31-.356-2.3-.642-1.68.2-3.536.058-4.293.9-10.833,12.04-21.517,24.213-32.421,36.016a8.923,8.923,0,0,0-3.44-.838c-5.321.117-8.7,2.085-11.761,6.361-5.272,7.356-11.678,13.891-17.424,20.922-1.489,1.822-2.294,4.2-3.414,6.326-.613-1.38-1.226-2.761-1.947-4.725-.381-.635-.655-.686-.928-.738-.632-.923-1.264-1.845-2.231-3.321C122.012,236.469,120.921,236.448,120.3,239Z"
                    fill="#fdfdfd"
                />
                <path
                    id="Path_61851"
                    data-name="Path 61851"
                    d="M139.161,329.414c2.456-1.066,5.62.966,7.62-3.222,1.295-2.711,5.829-3.876,9.118-5.857l-6.031-3.936,5.118-.685.223-1.459-15.476-3.073c2.576-2.968,4.94-3.718,8.338-2.587,2.45.816,5.581,1.91,7.369-2.652l-12.432-5.487,2.983-6.577c-.462-1.779-2.134-3.091-1.161-6.183,1.107-3.519-3.627-4.622-6.475-5.779-1.829-.743-4-.635-6.121-2.048l6-1.238c3.388-2.152-5.891-1.325-.051-4.278A3.177,3.177,0,0,0,138,272.14l-5.2-2.276c1.761-2.47,3.435-4.818,5.259-7.87a2.581,2.581,0,0,0-2.043-.986h-2.724c-3.881-2.458,6.16-3.972-.71-6.753.359-2.714-.268-5.582.884-7.089,5.1-6.675,10.672-13,16.207-19.334.688-.788,2.178-.876,3.58-1.086a20.991,20.991,0,0,0,3.132-.733c4.213-2.33,8.677-4.05,11.729-7.157,4.556-4.639,7.818-10.524,12.188-15.378A112.007,112.007,0,0,1,193.848,191.3a5.969,5.969,0,0,1-1.26,2.647c.113.323.492.556,1.167.665.956-.616,1.617-1.108,2.615-1.669,5.462-4.26,11.13-7.945,15.6-12.742,10.978-11.77,21.406-24.052,32.056-36.129l2.55-1.852c3.444,11.078-.676,22.052.466,31.917,1.94,2.589,4.292,4.407,4.751,6.618.93,4.475.952,9.16,1.07,13.765a4.612,4.612,0,0,1-1.7,3.167c-7.757,6.128-15.532,12.24-23.478,18.119-3.331,2.465-7.085,4.36-10.646,6.514l-1.013-.9c-.345,3.1-.082,6.44-1.165,9.259-2.157,5.612-4.172,11.637-7.818,16.247-9.354,11.827-19.508,23.027-29.48,34.357-2.727,3.1-5.938,5.77-9.377,9.065a7.78,7.78,0,0,0-.938,1.2l2.183.261a4.353,4.353,0,0,1,1.4-.49c9.526.189,14.883-5.905,19.7-12.92,5.323-7.757,10.508-15.625,16.207-23.1,2.78-3.647,6.59-6.509,10.395-10.052a.877.877,0,0,0-.138-1.088c1.159-7.916,3.21-15.528,9.235-21.235,7.217-6.836,14.676-13.418,22.071-20.064.521-.468,1.6-.969,2.03-.736a3.216,3.216,0,0,1,1.5,2.083,32.619,32.619,0,0,1,.131,5.486c-.335,8.767-.647,17.535-1.146,26.293-.1,1.715-.987,3.384-2.081,5.469-10.858,4.218-17.021,12.928-24.038,20.774l15.33-8.674c-2.332,3.646-4.2,6.56-6.034,9.464.025-.01.055-.055-.243-.4a9.7,9.7,0,0,0-2.769,2.406c.025-.011.051-.059-.168-.337a4.5,4.5,0,0,0-1.967.821,19.412,19.412,0,0,1-3.539,1.762c-9.56,2.562-10.331,10.023-10.2,19.138l7.556-6.074c2.655,3.326,4.727,1.776,7.087-1.006,1.258-1.484,3.366-2.314,5.193-3.234,4.036-2.032,8.656-3.285,12.1-6.032,5.98-4.772,11.513-4.421,16.276,2.123,3.7,5.089,7.08,10.474,11.236,15.166,8.791,9.925,17.783,19.694,27.112,29.112,5.493,5.546,11.791,10.295,17.828,15.488a9.54,9.54,0,0,1-2.363.707A5.123,5.123,0,0,0,315.209,335c-1.381,3.227-2.98,6.441.833,10.306-3.622,0-5.874,0-8.84-.128a3.128,3.128,0,0,0-1.722.89,10.124,10.124,0,0,0,1.486,3.018,4.559,4.559,0,0,1,1.711,1.636,1.259,1.259,0,0,0,.332,1.042,34.463,34.463,0,0,1,4.349,3.806c-.523,1.037-.95,1.729-1.376,2.421-2.711.056-6.142-3.212-7.97,1.841-.129.355-4.355-.773-6.636-1.624a2.014,2.014,0,0,1,.418-.871c.211.3.5.414,1.417.211a5.2,5.2,0,0,0-.069-2.934c-1.691-1.35-1.975-2.426,1.043-3.35a3.961,3.961,0,0,0-.135-2.4l-4.732-3.725c1.95-.1,2.953-.156,4.547-.282.686-.2.879-.411.859-.434a7.787,7.787,0,0,0-.652-.61l-2.517-5.184,1.014-.913-4.7-1.721,3.449-3.15c-1.2-3.556-2.207-6.38-3.091-9.243-.707-2.29-1.26-4.627-2.01-7.653a6.428,6.428,0,0,0-1.11-1.921L290.057,317c-.758,1.707-1.516,3.414-2.536,5.536a20.151,20.151,0,0,0-.473,3.484c-1.081,1-2.768.8-1.453,3.8,1.193,2.723-1.129,6.985-2.091,11.453,1.722,1.526,1.4,3.794-2,5.486a19.3,19.3,0,0,1-4.4,1.24,13.215,13.215,0,0,1-1.788-.157c-.289-.508-.578-1.016-1.131-1.93a2.406,2.406,0,0,1-.322-.915l.676-6.13a19.358,19.358,0,0,1-3.447-4.846c1.813-.3,2.916-.517,5.452-1.005l-4.361-1.595a4.974,4.974,0,0,1,.383-2.2A4.343,4.343,0,0,0,271,327.032c-3.165-.74-.492-2.376.048-3.717a4.309,4.309,0,0,0,.993-2.329,5.337,5.337,0,0,1-.7-2.617,11.194,11.194,0,0,1,2.385-.979l-2.731-2.083-2.019-7.2c-.726-2.589-1.452-5.178-2.533-8.321-.559-.925-.763-1.3-.967-1.666l-.52,1.879c-.348,2.981-.7,5.961-1.367,9.421a12.442,12.442,0,0,0,.367,3.7,1.763,1.763,0,0,1-1.083.859,6.529,6.529,0,0,0-2.067,1.474l2.219,1.477c-.766,2.509-1.608,5-2.189,7.551-.063.277,1.384.9,2.56,1.623a31.459,31.459,0,0,1-4.3,2.78c-.8.086-1,.085-1.207-.252a3.757,3.757,0,0,0-1.893-.275c-.2-.423-.407-.846.041-1.321a10.7,10.7,0,0,0,1.838-.45l-1.806-.759c-.667-7-1.334-13.995-2-21.761-.423-2.419-.845-4.068-1.549-6.82L250.982,304c-.644,1.748-1.287,3.5-2.338,5.734a8,8,0,0,0,1.306,3.4l-3.117,10.313-7.407-2.6,2.9-3.394-2.123-2.49c1.032-1.124,1.961-2.136,3.229-3.666a6.335,6.335,0,0,0-2.51-2.267c.5-2.788.646-5.513-.834-8.1a9.951,9.951,0,0,0,1.9-2.183L240,298.111l-5.535-17.656-1.2-.267c-1.092,4.917-2.185,9.834-3.57,15.282a2.171,2.171,0,0,0,.294,1.568,8.885,8.885,0,0,1-.711,3.524c-1.208-.149-1.938-.2-2.667-.246L227,301c-.885.781-1.769,1.562-3.131,2.684a1.545,1.545,0,0,0,.071,1.481c6.152,5.095-3.06,4.334-2.528,7.634a19.188,19.188,0,0,1,3.982,2.778,35.579,35.579,0,0,1-3.357,2.809l3.726,1.3c-.88,1.484-1.759,2.968-3.021,4.837a8.227,8.227,0,0,1-1.171.875l1.433.518,3.766,1.384c-3.083,2.045-5.624,3.731-8.748,5.6a1.649,1.649,0,0,0-.806,1.089c-.049.451-.1.9-.155,1.955a1.31,1.31,0,0,0,.935.907c.539.193,1.079.385,2.056.813a3.146,3.146,0,0,1,.827,1.294l-10.613-.657-.119-1.254,4.307-1.679-1.914-4.009c5.165-2.386,5.165-2.386.563-6.985a14.655,14.655,0,0,1,1.971-1.124l-2.184-2.01a9.355,9.355,0,0,1,.711-2.838c.841-.653,1.3-1.014,1.75-1.375l-2.919-4.4,2.64-3.346a10.547,10.547,0,0,1-3.145-2.341c.625-.268.721-.389.816-.511l-.744-.411c-.98-1.154-3.36-2.108.044-4.042a5.047,5.047,0,0,0-.039-2.966c-1.674-3.049-2.843-6.015,1.158-7.74a52.037,52.037,0,0,1-3.176-6.294,4.875,4.875,0,0,0-1.468-1.993l-.867,1.886c-.862,1.808-1.724,3.616-2.861,5.949a5.026,5.026,0,0,0,.2,2.211,46.909,46.909,0,0,1-.56,5.4c-.731,1.484-1.207,2.533-1.749,3.928a6.111,6.111,0,0,0,.465,1.647c-.074,1.3-.187,2.609-.207,3.915-.013.876.14,1.752.16,2.63.03,1.322.008,2.645.008,4.248-3.37,2.271-5.393,1.464-5.38-3.442,0-.82-.789-1.656-1.257-2.46-1.018-1.748-2.064-3.48-3.1-5.219a49.432,49.432,0,0,1-2.443,5.428c-.519.881-1.665,1.392-3.128,2.414A10.977,10.977,0,0,0,185.987,314a4.346,4.346,0,0,0-1.25.586c-1.149.342-1.839.512-3.6.945L185,316.992c1.6,1.613,6.382,2.989-.134,5.6a12.815,12.815,0,0,0-.534,4.17l4.308.679-7.009,1.482a19.9,19.9,0,0,1,2.944,4.724c-2.018.644-4.667.207-2.539,3.342a20.024,20.024,0,0,1-1.166,2.769c-.418.467-.608.577-.609.688s.172.279.3.316.294-.055.444-.09a13.821,13.821,0,0,1,1.1,3.3c-.119,1.113-.161,1.552-.556,2.014-1.287.023-2.219.023-3.249.023l.693,1.984-5.685.273c-.713-3.511-1.189-6.486,2.981-7.682a31.721,31.721,0,0,1-1.4-7.065,5.578,5.578,0,0,0-1.808-2.728,2.052,2.052,0,0,1,.25-.7,15.63,15.63,0,0,1,1.945-1.746l-2.249-.421-5.957-21.409c-1.437,2.655-2.23,4.121-3.432,6.059-.376,1.674-4.673.972-1.722,3.457-.774,2.357-1.682,4.682-2.258,7.086-.244,1.018.211,2.2.386,3.624a21.8,21.8,0,0,0-4.6.894c-2.313,3.413.227,2.559,1.511,2.824l3.857,1.335-10.243,4.6v-4.755c-3.6-.688-7.081-1.352-10.957-2.076-.4-.06-.448-.146-.448-.146m98.5-159.5-.068-.749a13,13,0,0,0-1.543.485c-.2.141-.352.318-1.007.83a8.376,8.376,0,0,1-1.877,1.529c-2.4,2.322-4.81,4.644-7.75,7.137a21.441,21.441,0,0,1-1.727,1.707l-.568,1.429a24.015,24.015,0,0,1,2.611-1.238,7.031,7.031,0,0,1,1.858-1.355c2.424-2.385,4.848-4.77,7.67-7.445a4.837,4.837,0,0,1,1.356-1.277,2.752,2.752,0,0,1,1.045-1.052m-12.487,33.3,1.283-2.037-.76-.562a18.277,18.277,0,0,1-2.487,2.441l-.824,1.765a28.542,28.542,0,0,0,2.789-1.607m11.9-11.968c4.092-4.686,8.165-9.385,10.956-14.9l-1.536-1.063c-3.741,4.706-7.482,9.412-11.834,14.6l-2.7,4.032,1.967,1.312a50.3,50.3,0,0,1,3.149-3.987M184.151,302.278c4.08-1.732,8.3-3.2,12.207-5.257,6.257-3.292,8.32-10.2,5.069-17.765-6.377,7.75-12.478,15.163-19.24,22.625l-.967.752a17.531,17.531,0,0,0,2.931-.354m35.992-118.293c-4.053,4.158-8.282,8.163-12.074,12.547a12.606,12.606,0,0,0-3.191,6.755c-.71,10.786-.943,21.6-1.346,32.41l1.368.439c1.062-1.9,2.564-3.69,3.1-5.732,1.853-7,3.86-14.019,4.89-21.163,1.287-8.93,2.373-17.739,9.553-25.124l.408-1.508a28.2,28.2,0,0,1-2.712,1.375m-51.057,72.249c8.227-6.061,16.779-11.745,24.5-18.394,2.579-2.221,3.843-6.813,4.275-10.489.692-5.889.319-11.924.1-17.886-.054-1.455-1.272-2.867-2.585-4.57-1.176.344-2.352.687-4.181,1.2-2.529,1.868-4.827,4.276-7.639,5.486-5.113,2.2-7.439,6.373-9.107,11.1-1.651,4.674-2.692,9.581-8.417,11.246-.868.252-1.425,1.721-2.035,2.684-1.675,2.645-3.178,5.409-4.973,7.967-4.736,6.749-9.591,13.415-14.37,20.211a3.563,3.563,0,0,0-.674.076,6.524,6.524,0,0,1-1.61,2.169c.213.239.426.479,1.531.811.426,3.614.634,7.274,1.376,10.822a9.342,9.342,0,0,0,2.707,4.474,37.343,37.343,0,0,0,5.427,3.673l34.261-32.731c-12.527,6.444-24.72,8.777-38.642,10.24,5.323-6.045,9.692-10.97,14.019-15.932,6.624-7.6,12.875-15.151,16.682-24.971,2.08-5.365,8.691-8.974,13.417-12.884.071.157.141.314-.14,1.1-.535,1.067-1.74,2.875-1.5,3.09,3.16,2.863.563,4.584-1.052,6.575a5.662,5.662,0,0,0-1.409,2.465c-1.279,9.326-5.161,17.15-12.495,23.279-3.149,2.631-5.831,5.82-9.381,8.818l-.934.78a10.114,10.114,0,0,0,2.856-.407m-17.062-11.615-16.23,8.041.878,1.845,10.087-4.578-.718,5.485,11.443-12.527-.936-.774c-1.312.679-2.623,1.359-4.523,2.507m84.156-13.03,12.3-11.47-1.439-1.444L231.86,232.8l.958,1.047c.94-.614,1.879-1.227,3.363-2.265m-8.046-34.434-2.191,3.825c4.977-2.832,4.977-2.832,2.191-3.825M192.089,302.5l.545.4c-.025-.29-.05-.579-.545-.4M171.465,320l-.236.672c.228-.072.456-.145.236-.672M139,277.471l.681.223C139.6,277.464,139.525,277.234,139,277.471Z"
                    fill="#f8f8f8"
                />
                <path
                    id="Path_61852"
                    data-name="Path 61852"
                    d="M333.985,303.786a7.309,7.309,0,0,1,2.737.371,1.762,1.762,0,0,1-.978,1.815,20.151,20.151,0,0,0-2.391.333c-.958.626-1.657,1.157-2.355,1.688-.674-1.74-1.348-3.48-2.189-5.905A17.574,17.574,0,0,0,326.6,298.8l-.546,3.2a19.165,19.165,0,0,1-1.989,5.9c-1.264.139-1.776.167-2.288.2a77.526,77.526,0,0,1,.9-11.241,6.619,6.619,0,0,1,1.984.8,13.574,13.574,0,0,0-.435-2.244c-1.273-1.264-1.741-4.238-3.741-1.485.059-.058-.022-.383-.022-.383-.018-1.385.5-3.1-.134-4.106-11.169-17.771-21.757-35.975-36.074-51.522-4.493-4.879-9.429-9.355-14.253-13.92a48.747,48.747,0,0,0-4.769-3.557l1.451-1.9,11.421,7.233,1.3-.422c-1.3-4.713-2.6-9.426-3.788-14.641.245-.613.377-.724.509-.836a75.453,75.453,0,0,1,3.713,6.77c3.025,7.074,5.767,14.271,8.865,21.312a16.517,16.517,0,0,0,3.873,5.04c9.971,9.43,19.269,19.432,26.728,31.012,1.125,1.747,1.853,3.746,2.8,5.609,3.155,6.186,6.364,12.345,9.464,18.559a20.707,20.707,0,0,1,1.314,4.765C333.265,303.681,333.625,303.734,333.985,303.786Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_61853"
                    data-name="Path 61853"
                    d="M193.8,190.74c-4.528,4.22-9.373,8.155-13.5,12.738-4.369,4.854-7.632,10.739-12.188,15.378-3.052,3.107-7.516,4.826-12.106,7.134-1.261-.048-1.764-.064-2.122-.392,3.842-3.632,7.539-6.952,11.235-10.272,10.72-12.141,21.4-24.314,32.237-36.353.757-.842,2.612-.7,4.305-.639a1.856,1.856,0,0,1,.428.885l-1.869,4.727,1.29,1.036c5.658-5.812,11.44-11.51,16.94-17.468,6.142-6.653,12.01-13.559,18.038-20.318a69.44,69.44,0,0,1,5.178-5.088,6.213,6.213,0,0,1,2.239,1.691c-10.529,12.353-20.958,24.635-31.936,36.4-4.475,4.8-10.142,8.482-15.838,12.6a1.859,1.859,0,0,1-.867-1.8c.442-.767.659-1.327,1.082-2.046a3.392,3.392,0,0,0,.266-1.29,5.588,5.588,0,0,1-1.151,1.223,13.874,13.874,0,0,0-1.619,1.852c-.043,0-.045.007-.045.007m5.275-4.391.683-1.512c-.277-.007-.769-.089-.8-.009C198.74,185.467,198.6,186.136,199.077,186.35Z"
                    fill="#060606"
                />
                <path
                    id="Path_61854"
                    data-name="Path 61854"
                    d="M241.959,375.113l6.383,1.126c-1.233,6.8-2.467,13.6-4.321,20.636a1.839,1.839,0,0,0-.013,1.8l-2.579,2.164c1.523,1.122,4.761,2.141,1.312,5.63a4.667,4.667,0,0,0-.577,1.524c-.4,1.371-1.541,3.536-1.065,3.986,3.165,2.99.179,5.3-.363,7.925-.254,1.228.446,2.652.738,4.114l-5.175,2.616c-4.748-3.621-1.1-8.151-1.425-12.274a14.65,14.65,0,0,0-1.41-5.923c-1.3-2.309-2.966-4.1-.544-6.773.625-.69-.189-2.556-.069-3.857.264-2.87,1.048-5.734.963-8.581-.074-2.493-1.045-4.96-1.341-7.846a19.79,19.79,0,0,0,.573-3.488,26.836,26.836,0,0,1,2.73-4.061,3.759,3.759,0,0,1,3.267-.87,9.659,9.659,0,0,0,2.914,2.156m-5.4,5.833,2.325,6.993,1.718.226c1.029-1.986,2.648-3.912,2.861-5.982.123-1.189-1.841-2.942-3.259-3.768C239.648,378.092,238.019,379.614,236.557,380.946Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_61855"
                    data-name="Path 61855"
                    d="M139.121,329.015a3.722,3.722,0,0,1,.066.53c.561,1.6,1.147,3.165,1.772,5.091-6.845-2.832-6.691-6.934,1.617-15.985-4.747-.982-8.766-2.382-12.821-2.492-4.1-.111-7.136-.837-8.7-6.042a68.967,68.967,0,0,1,6.42-3.344c4.216-1.7,5.383-4.12,4.132-8.548-.752-2.661-1.091-5.438-1.615-8.163-.154-.8-.091-2.171-.49-2.321-5.871-2.213-5.844-7.3-5.623-12.737-3.511,1.1-7.064-.064-8.259,4.677-.7,2.783-4.524,1.576-7.5-2.611a5.069,5.069,0,0,1,1.142-.685c2.068-.585,5.43-.581,5.933-1.786.758-1.818-.4-4.483-.9-6.755a20.976,20.976,0,0,0-1.259-2.478,47.581,47.581,0,0,1,10.514,2.738c1.489.641,3.327,2.856,3.27,4.289-.254,6.444,1.091,11.681,7.086,15.3,1.281.774,1.639,3.685,1.75,5.65.2,3.473-.155,6.975-.206,10.465-.009.636.618,1.373.448,1.9-2.4,7.509,2.942,9.843,8.114,12.328a4.583,4.583,0,0,1,1.186.885c.221.217.314.564.123.2C143.1,322.508,141.09,325.561,139.121,329.015Z"
                    fill="#050506"
                />
                <path
                    id="Path_61856"
                    data-name="Path 61856"
                    d="M331,289c-1.376-2-3.4-3.817-4.022-6.029-3.479-12.395-10.657-22.229-20.109-30.672a21.712,21.712,0,0,1-4.484-6.107,13.176,13.176,0,0,1,4.132-1.19c3.523-.432,2.831-1.958,1.006-4.108-.06-.5-.09-.7.214-.955,5.075-2.365,6.758,1.6,7.943,4.43,1.838,4.38,4.9,6.11,9.2,6.644a3.356,3.356,0,0,1,1.961,1.292,11.591,11.591,0,0,1-3.473.6,41.812,41.812,0,0,0-6.457.13c-.452.079-1.151,2.961-.664,3.425a16.056,16.056,0,0,0,5.229,3.128,4.879,4.879,0,0,0,3.237-.5c3.278-1.432,5.383-.63,5.961,2.959A10.235,10.235,0,0,0,329,264c1.474,5.264,3.085,10.495,4.36,15.806a27.522,27.522,0,0,1,.3,7.747A12.9,12.9,0,0,1,331,289m.6-9.712-1.676-1.893-1,.379.744,6.1,1.775-.012a23.806,23.806,0,0,0,.157-4.575M310.2,247.609l.014-1.182c-.163,0-.469-.013-.47,0A1.188,1.188,0,0,0,310.2,247.609Z"
                    fill="#070708"
                />
                <path
                    id="Path_61857"
                    data-name="Path 61857"
                    d="M205.745,380.9c2.949-3.672,5.715-7.1,11.521-5.122,2.774.944,6.135.162,9.805.162-.342,2.7-.7,5.645-1.166,8.574a4.841,4.841,0,0,1-2.237-.694c-.855-1.035-1.3-1.5-1.75-1.971l.192,2.151a76.684,76.684,0,0,1-2.061,11.992c-.483.449-.3.805-.108,1.161l3.038,1.219-3.509,2.183c-.091,6.71-1.654,12.586-7.018,16.213-1.053-11.142-2.092-22.142-3.35-33.878A9.7,9.7,0,0,0,205.745,380.9Z"
                    fill="#eee"
                />
                <path
                    id="Path_61858"
                    data-name="Path 61858"
                    d="M329,235c-2.977-3.765-5.954-7.529-8.7-11.767A25.4,25.4,0,0,1,322,221a100.067,100.067,0,0,1,11,7.006c2.386,4.146,4.695,7.57,7,10.994,0,0,0,.5.033,1.1A23.892,23.892,0,0,0,343,244c.332,1.1.664,2.2,1.04,3.97A6.076,6.076,0,0,0,346,250a81.549,81.549,0,0,1,5.865,7.088,45.566,45.566,0,0,1-2.456,7.985,13.839,13.839,0,0,1-2.212,2.844,19.9,19.9,0,0,1-2.818-2.922c1.72-1.749,4.157-3.473,4.19-5.241.083-4.48-7.693-8.76-12.076-7.656-2.341.59-4.985-.026-7.32-.355a8.809,8.809,0,0,1,2.212-1.9,12.719,12.719,0,0,0,1.889.087c3.385-1.826,4.216-3.752.728-5.933a21.988,21.988,0,0,1-1.7-4.873C333.562,235.192,331.241,235.135,329,235Z"
                    fill="#070708"
                />
                <path
                    id="Path_61859"
                    data-name="Path 61859"
                    d="M254,386.862l-2.409-10.4c6.044.227,8.372,1.824,7.308,5.391l7.557,1.514c-1.736,4.842-3.5,9.77-5.672,15.169a2.036,2.036,0,0,0,.148,1.637l1.9,2.112-3.162,2.638L262.4,408.1a43.771,43.771,0,0,0-2.376,3.945,33.346,33.346,0,0,0-1.314,3.9,18.9,18.9,0,0,1-4.2-2.524c.25-1.077.357-1.744.463-2.411a2.681,2.681,0,0,1-.214-1.871c.293-.722.2-.925.112-1.129-.327-5.968-.654-11.935-.579-18.485a5.161,5.161,0,0,0-.286-2.664m1.02,18.6.651.2C255.6,405.457,255.527,405.252,255.021,405.458Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_61860"
                    data-name="Path 61860"
                    d="M249.047,243.137c5.97,8.7,5.234,15.375-3.018,21.34a118.492,118.492,0,0,1-14.946,8.668c-1.273.662-3.183.1-6.115.1,1.831-2.632,2.827-4.063,4.271-5.918a28.647,28.647,0,0,0,1.8-2.353s-.026.048.291.188a13.27,13.27,0,0,0,2.725-2.187s-.03.045.292.153c2.346-2,4.7-3.886,6.322-6.267C243.683,252.437,246.277,247.727,249.047,243.137Z"
                    fill="#f7f7f7"
                />
                <path
                    id="Path_61861"
                    data-name="Path 61861"
                    d="M332.9,249.963a3.76,3.76,0,0,1-1.647-.422c-2.978-2.2-5.434-4.179-8.082-5.851-8.206-5.182-13.106-12.734-16.211-21.729-1.867-5.407-4.05-10.7-5.825-16.342a17.248,17.248,0,0,1,3.767,2.42,215.359,215.359,0,0,0,26.051,38.007C331.743,247.761,332.319,248.862,332.9,249.963Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_61862"
                    data-name="Path 61862"
                    d="M271,250a8.121,8.121,0,0,1,1.209-1.781A18.406,18.406,0,0,0,274,246a36.35,36.35,0,0,1,1.417-5.6A19.235,19.235,0,0,1,280,240a60.73,60.73,0,0,1,.734,7.76c-.868,2.259-3.541,4.128.264,5.24,4.31,6.767,8.62,13.533,12.922,20.97A8.6,8.6,0,0,1,290,275q-6.5-7.717-13-15.443a24.352,24.352,0,0,1-3-4.563A37.462,37.462,0,0,0,271,250Z"
                    fill="#070708"
                />
                <path
                    id="Path_61863"
                    data-name="Path 61863"
                    d="M358.289,247.907c.421-2.65.9-6.912,1.951-7.06,4.411-.619,3.186,4.115,4.707,7.144,3.017,7.342,2.93,15.57,10.084,20-1.01,4.845-1.9,9.72-3.111,14.513-.322,1.274-1.581,2.349-2.555,3.379-.149.158-1.594-.58-1.575-.64.328-1.072,1.21-2.13,1.148-3.14-.246-4.008.989-7.842-1.119-12.1-2.781-5.616-3.83-12.089-5.87-19.031a17.628,17.628,0,0,1-1.334,3.576,3.123,3.123,0,0,1-1.6.454A58.438,58.438,0,0,0,358.289,247.907Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61864"
                    data-name="Path 61864"
                    d="M275,172a8.067,8.067,0,0,1,2.613,1.877c-.274,1.011-.444,1.567-.613,2.122-3.185-.222-6.045-.407-9.141,1.711-3.92,2.682-10.276.29-12.586-4.413-2.812-5.725-3.335-11.8.131-17.521.436-.719,3.1-.843,4.138-.235,1.095.641,1.481,2.493,1.963,4.13a13.951,13.951,0,0,1-3.738-1.131c-3.161,3.8-3.552,9.75.087,12.212,1.785,1.208,5.2.01,8.2-.112L263,162c.735.289,1.8.362,2.152.9,2.446,3.741,5.222,7.028,9.495,8.771a9.49,9.49,0,0,1-1.184,1.314l.629.546Z"
                    fill="#060606"
                />
                <path
                    id="Path_61865"
                    data-name="Path 61865"
                    d="M307.4,240a1.141,1.141,0,0,1-.185.848,2.4,2.4,0,0,1-1.4-.137c-4.5-6.305-9.1-12.541-13.427-18.96-1.24-1.839-1.644-4.23-2.517-6.332-4.065-9.791-8.161-19.57-12.2-29.79a1.312,1.312,0,0,1,.475-.773,8.623,8.623,0,0,1,1.615.754c1.307.928,2.137,1.5,2.966,2.082,1.162.759,2.324,1.517,3.9,2.65,2.625,2.509,4.832,4.644,7.039,6.779a14.047,14.047,0,0,1,1.357,2.784c.015.544-.051,1.016-.387.988-4.1-2.755-6.06-7.877-11.959-9.135,3.391,6.752,7.407,12.458,9.184,18.793C294.965,221.618,300.623,231.03,307.4,240Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61866"
                    data-name="Path 61866"
                    d="M193.292,388.972l-5.4,8.746c-5.726-3.756-6.453-7.631-2.5-12.18l-10.872-1.692c5.286-8.3,13.156-4.127,20.605-4.947-.435,2.892-.807,5.369-1.494,8.394A4.593,4.593,0,0,0,193.292,388.972Z"
                    fill="#eee"
                />
                <path
                    id="Path_61867"
                    data-name="Path 61867"
                    d="M152.972,226.544c-1.118.412-2.608.5-3.3,1.288-5.535,6.334-11.1,12.659-16.207,19.334-1.152,1.507-.525,4.375-1.014,6.751a31.878,31.878,0,0,1-3.5-5.766c1.06-2.515,1.866-4.9,3.355-6.717,5.746-7.03,12.153-13.565,17.424-20.922,3.064-4.276,6.441-6.244,12.072-6.09-.659,1.243-2.119,2.206-3.339,3.412-2.317,2.289-4.511,4.7-6.671,7.143a11.522,11.522,0,0,0,1.164,1.505C152.951,226.5,152.972,226.544,152.972,226.544Z"
                    fill="#050506"
                />
                <path
                    id="Path_61868"
                    data-name="Path 61868"
                    d="M311.813,309.189c-1.889-1.908-3.687-3.919-5.693-5.695a44.5,44.5,0,0,0-6.375-4.481c-1.48-.43-2.31-.721-3.342-1.084l-.429,3c-5.995-7.061-11.989-14.123-17.627-21.662a17.254,17.254,0,0,0-.451-4.545,60.672,60.672,0,0,1-2.785-6.5c.2-.831.4-1.034.662-1.178,5.32,6.57,11.425,12.438,14.263,20.931,1.084,3.243,4.9,6.141,8.163,7.961,5.573,3.111,10.989,6.077,13.933,12.517A1.305,1.305,0,0,1,311.813,309.189Z"
                    fill="#eee"
                />
                <path
                    id="Path_61869"
                    data-name="Path 61869"
                    d="M272.072,398.812c-.673-2.754-1.459-5.486-1.979-8.268a61.16,61.16,0,0,1-.528-6.154h12.854c-.634,1.908-.806,4.172-1.979,5.634-3.582,4.467-3.779,9.108-1.892,14.224,1.076,2.917-2.206,6.543-7.5,6.8l3.241-2.954a41.553,41.553,0,0,1-1.894-6.712A7.92,7.92,0,0,0,272.072,398.812Z"
                    fill="#eee"
                />
                <path
                    id="Path_61870"
                    data-name="Path 61870"
                    d="M298.727,382.274c-.951,2.313.142,6.081-3.571,5.886v13.627l-5.729-5.1,1.73-8.08-3.976-5.784,7.558-1.431-1.368-9.111c1.1-.171,2.37-.37,4.224-.648,1.867.074,3.151.228,4.435.382a6.958,6.958,0,0,0-.372,2.379c-1.068,1.835-2.586,3.086-3.514,4.68C297.73,379.782,298.5,381.184,298.727,382.274Z"
                    fill="#eee"
                />
                <path
                    id="Path_61871"
                    data-name="Path 61871"
                    d="M213.823,348.558c.2.9.861,2.146.5,2.635a29.847,29.847,0,0,1-4.067,3.776l5.352,3.835c.148,1.159-4.486,3.807,1.638,4.571l-1.317,1.408-11.185-3.249,4.086-2.3-9.167-2.384,10.239-4.282-4-4.836c2.008-4.177,5.109-6.175,10.467-4.7a15.142,15.142,0,0,1-2.461,2.877A3.8,3.8,0,0,0,213.823,348.558Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61872"
                    data-name="Path 61872"
                    d="M249.007,242.77c-2.731,4.957-5.325,9.667-8.342,14.089-1.625,2.381-3.976,4.266-6.347,6.277a109.857,109.857,0,0,1,5.711-9.572l-15.33,8.674c7.017-7.846,13.18-16.556,23.821-20.473C248.905,241.916,248.936,242.159,249.007,242.77Z"
                    fill="#060606"
                />
                <path
                    id="Path_61873"
                    data-name="Path 61873"
                    d="M349.015,298.96c-.987-3.427-2.089-6.827-2.917-10.291a11.6,11.6,0,0,1,.206-6.44l1.707,5.035c1.761-2.066,4.332-4.079,4-4.852-2.743-6.412,2.149-3.929,4.678-4.383l-4.915,12.914,1.926.444.237,5.414,1.272.162c-1.859,2.318-3.718,4.636-5.918,7.02-.34.065-.463.08-.463.08a13.663,13.663,0,0,1,.388-3.787A1.411,1.411,0,0,0,349.015,298.96Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61874"
                    data-name="Path 61874"
                    d="M298.961,382.03c-.465-.846-1.232-2.247-.816-2.961.928-1.594,2.446-2.845,3.786-4.565,5.623,2.078,11.183,4.485,16.987,7.192a1.725,1.725,0,0,1,.136,1.141c-6.04.088-11.74,1.007-16.179,5.594C300.961,386.053,303.754,381.918,298.961,382.03Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61875"
                    data-name="Path 61875"
                    d="M302.5,372.011a35.272,35.272,0,0,1-4.586-.64,17.348,17.348,0,0,1,3.188-2.933l-6.218-3.985,12.56-1.483-.4,3.912,12.107,3.418-.23,1.711Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61876"
                    data-name="Path 61876"
                    d="M344,265l3.2,2.916a13.839,13.839,0,0,0,2.212-2.844A72.415,72.415,0,0,0,352,257.4c2.416.748,3.307,2.477,2.05,5.32-.033.3.055.35.055.35a21.649,21.649,0,0,0-3.323,3.466,37.25,37.25,0,0,0-2.292,5.439,32.386,32.386,0,0,1-5-1.339,4.4,4.4,0,0,1-.562-1.859c-.016-.111-.226-.215-.367-.281a1.013,1.013,0,0,0-.364-.008l-.741,5.718a58.712,58.712,0,0,0-4.075-4.835,47.91,47.91,0,0,0-4.347-3.28A31.208,31.208,0,0,0,329.382,264a2.583,2.583,0,0,1,1.557-1.853c1.075.327,1.569.589,2.443.894a39.546,39.546,0,0,1,5.764,1.251A29.842,29.842,0,0,0,344,265Z"
                    fill="#060606"
                />
                <path
                    id="Path_61877"
                    data-name="Path 61877"
                    d="M266.572,185.677c1.792.834,3.866,1.138,4.537,2.272.974,1.646.935,3.891,1.328,5.881-2.264.327-4.9,1.558-6.723.81-5.45-2.238-6.272-5.964-2.962-11.661C263.939,183.846,265.083,184.682,266.572,185.677Z"
                    fill="#060606"
                />
                <path
                    id="Path_61878"
                    data-name="Path 61878"
                    d="M265.783,234h-7.588c-1.787-4.806-1.842-10.18.042-16.547,4.177,4.731,7.834,8.619,11.11,12.806.635.812-.218,2.789-.7,4.477a9.193,9.193,0,0,1-2.864-.735m-6.644-3.246,4.7-1.943-3.571-3.917-1.24.809C259.028,227.14,259.028,228.575,259.139,230.755Z"
                    fill="#060606"
                />
                <path
                    id="Path_61879"
                    data-name="Path 61879"
                    d="M305.405,240.773a9.075,9.075,0,0,1,1.844.373c2.1,1.9,2.791,3.425-.732,3.856a37.9,37.9,0,0,0-4.166.845c-5.532-4.735-12.01-8.776-11.653-18.481,2.189,2.784,3.575,5.128,5.508,6.863A66.985,66.985,0,0,0,305.405,240.773Z"
                    fill="#060606"
                />
                <path
                    id="Path_61880"
                    data-name="Path 61880"
                    d="M247.66,354.969c2.242.45,4.1.988,5.966,1.526-.837,1.176-1.747,2.309-2.495,3.54-1.074,1.767-2.031,3.6-3.064,5.459-7.139-1.553-7.375-1.844-6.751-8.806C243.238,356.162,245.259,355.61,247.66,354.969Z"
                    fill="#050506"
                />
                <path
                    id="Path_61881"
                    data-name="Path 61881"
                    d="M262.979,161.7c.89,2.76,1.76,5.222,3.074,8.94-3,.122-6.416,1.319-8.2.112-3.639-2.462-3.248-8.414-.087-12.212,1.174.484,2.35.965,3.88,1.452A3.619,3.619,0,0,1,262.979,161.7Z"
                    fill="#070708"
                />
                <path
                    id="Path_61882"
                    data-name="Path 61882"
                    d="M205.333,381.063a8.611,8.611,0,0,1,3.63,1.442c-3.488,3.433-4.054,7.372-3.63,12.089a10.761,10.761,0,0,1-3.117.385,55.921,55.921,0,0,1-1.278-5.908,5.657,5.657,0,0,0-1.9-2.171l-1.193-5.676C200.5,381.224,202.709,381.224,205.333,381.063Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61883"
                    data-name="Path 61883"
                    d="M333.113,266.426a20.366,20.366,0,0,1,4.267,2.94,58.712,58.712,0,0,1,4.075,4.835l.741-5.718a1.013,1.013,0,0,1,.364.008c.14.065.35.169.367.281.071.487.082.982.188,1.852-.847,7.178-1.768,13.977-3.21,21.122a2.65,2.65,0,0,1-1.762-1.141c.284-2.17.222-4.458.913-6.49C341.563,276.746,336.89,271.952,333.113,266.426Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61884"
                    data-name="Path 61884"
                    d="M375.333,267.757c-7.455-4.2-7.368-12.423-10.369-19.4,3.811,4.274,7.592,8.933,11.59,13.778A22.37,22.37,0,0,1,375.333,267.757Z"
                    fill="#131313"
                />
                <path
                    id="Path_61885"
                    data-name="Path 61885"
                    d="M286.478,252.244c3.271,4.146,6.542,8.293,10.148,12.964,1.326,2,2.318,3.481,3.31,4.959l5.934,9-1.59,1.06c-6.091-8.789-12.183-17.578-18.2-26.927A2.948,2.948,0,0,1,286.478,252.244Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61886"
                    data-name="Path 61886"
                    d="M290.036,275.357c1.269-.477,2.573-.6,3.921-1.037,2.651,3.965,5.259,8.25,7.9,12.6C297.327,288.244,294.091,285.066,290.036,275.357Z"
                    fill="#060606"
                />
                <path
                    id="Path_61887"
                    data-name="Path 61887"
                    d="M276.4,357.9l5.539,3.9c-.514,1.236-1.172,3.107-2.082,4.847-.306.585-1.368,1.29-1.881,1.156-1.627-.424-3.65-.8-4.623-1.954-2.093-2.477-2.273-5.2,1.2-7.455A3.612,3.612,0,0,1,276.4,357.9Z"
                    fill="#eee"
                />
                <path
                    id="Path_61888"
                    data-name="Path 61888"
                    d="M149,350.593c-2.273-1.388-5.426-2.752-6.575-5.1-1.17-2.387-.366-5.741-.426-9.083,1.079.113,2.826.393,3.122,1.2C146.621,341.73,147.744,345.981,149,350.593Z"
                    fill="#050506"
                />
                <path
                    id="Path_61889"
                    data-name="Path 61889"
                    d="M358.694,254.886a10.708,10.708,0,0,0,1.832.086,19.168,19.168,0,0,1-1.793,4.3l-16.005-21.63,1.425-1.121C348.894,242.6,353.635,248.686,358.694,254.886Z"
                    fill="#d8d8d8"
                />
                <path
                    id="Path_61890"
                    data-name="Path 61890"
                    d="M180.584,359.073l6.542,2.432a16.81,16.81,0,0,1-17.13-.114c3.008-.851,5.635-1.594,8.842-2.319C179.806,359.084,180.195,359.079,180.584,359.073Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61891"
                    data-name="Path 61891"
                    d="M294.042,197.062a70.318,70.318,0,0,1-7.112-6.665,25.528,25.528,0,0,1,3.766-3.143C296.832,190.973,298.059,194.24,294.042,197.062Z"
                    fill="#060606"
                />
                <path
                    id="Path_61892"
                    data-name="Path 61892"
                    d="M311.338,397.75c-3.437.706-6.57,1.205-9.9,1.736v-9.495C304.925,392.574,308.283,395.059,311.338,397.75Z"
                    fill="#d8d8d8"
                />
                <path
                    id="Path_61893"
                    data-name="Path 61893"
                    d="M333.613,306.21a22.274,22.274,0,0,1,2.4-.188,2.8,2.8,0,0,1,2.561,3.711,5.128,5.128,0,0,0-.24,2.269,21.568,21.568,0,0,1-1.7,4.38c-1.4,2.13-3.046,2.8-3.686-.394a1.6,1.6,0,0,0,.884-.978,19.312,19.312,0,0,1-1.25-4.5A40.282,40.282,0,0,0,333.613,306.21Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61894"
                    data-name="Path 61894"
                    d="M180.474,358.591c-.279.488-.668.494-1.248.461a18.387,18.387,0,0,1-.894-4.023,10.605,10.605,0,0,1,.651-5.148,19.484,19.484,0,0,1,2.983.214l4.721,1.63a39.658,39.658,0,0,0-5.217,3.916,3.076,3.076,0,0,1-.266.8A6.557,6.557,0,0,0,180.474,358.591Z"
                    fill="#d8d8d8"
                />
                <path
                    id="Path_61895"
                    data-name="Path 61895"
                    d="M202.206,395.361a7.266,7.266,0,0,1,3-.405c-.562,4.475-1.456,8.951-2.244,12.9l-4.848-2.43C199.378,402.418,200.787,399.081,202.206,395.361Z"
                    fill="#d8d8d8"
                />
                <path
                    id="Path_61896"
                    data-name="Path 61896"
                    d="M276.786,357.918c-.973.027-1.557.068-2.435.087a43.619,43.619,0,0,1,4.2-3.8,20.259,20.259,0,0,1-4.048-3.844,12.237,12.237,0,0,1,3.48-.548l6.6,2.615C281.689,354.582,279.432,356.257,276.786,357.918Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_61897"
                    data-name="Path 61897"
                    d="M282.819,187.288a6.713,6.713,0,0,1-2.78-1.565,6.716,6.716,0,0,0-1.643-7.433c.729-1.36,1.166-2.325,1.6-3.289C284.937,179.157,285.5,181.443,282.819,187.288Z"
                    fill="#060606"
                />
                <path
                    id="Path_61898"
                    data-name="Path 61898"
                    d="M154.012,340.039l1.7-1.4c.708,2.315,1.371,4.486,2.177,7.324.174,1.134.205,1.6.237,2.068a7.714,7.714,0,0,1-.5,2.6,7.6,7.6,0,0,1-2.636.4c-.336-2.078-.672-4.157-1-7.028C154,342.153,154.005,341.1,154.012,340.039Z"
                    fill="#050506"
                />
                <path
                    id="Path_61899"
                    data-name="Path 61899"
                    d="M323.227,323.371a23.442,23.442,0,0,1-3.839,1.9,1.47,1.47,0,0,0-.407-1.166l-.818.94c-.647-.656-1.949-1.733-1.84-1.9a23.035,23.035,0,0,1,4.488-5.118c1.03-.008,1.411-.006,1.792,0a3.239,3.239,0,0,1,.973,1.79A20.784,20.784,0,0,0,323.227,323.371Z"
                    fill="#eee"
                />
                <path
                    id="Path_61900"
                    data-name="Path 61900"
                    d="M305.183,207.82c-1.452-.685-2.619-1.589-4.009-2.162-.222.33-.152.422.137.14a8.775,8.775,0,0,0-1.339-2.266c-.344-1.046-.658-1.789-.971-2.532l2.264-2.635A100.593,100.593,0,0,1,305.183,207.82Z"
                    fill="#060606"
                />
                <path
                    id="Path_61901"
                    data-name="Path 61901"
                    d="M181.749,375.119c-1.244.384-2.726.8-3.791.311a29.294,29.294,0,0,1-4.685-3.295C176.907,368.417,178.043,368.739,181.749,375.119Z"
                    fill="#eee"
                />
                <path
                    id="Path_61902"
                    data-name="Path 61902"
                    d="M265.9,234.373a6.9,6.9,0,0,1,2.715.742c.945,3.434,1.6,6.736,2.3,10.7.033.66.072,1.153.072,1.153C269.332,242.892,267.678,238.819,265.9,234.373Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61903"
                    data-name="Path 61903"
                    d="M354.041,263.059c3.451-.616,4.618.61,3.241,3.922-.848,2.038-1.728,4.062-2.764,6.492-4.818-3.281,1.284-6.659-.456-10.008C354.1,263.065,354.016,263.016,354.041,263.059Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61904"
                    data-name="Path 61904"
                    d="M200.385,325.144c-1.024-1.614-1.814-3.01-3.329-5.688l7.422-.6,1.083,1.815A49.123,49.123,0,0,1,200.385,325.144Z"
                    fill="#070707"
                />
                <path
                    id="Path_61905"
                    data-name="Path 61905"
                    d="M321.851,220.7a5.54,5.54,0,0,1-1.585,2.185c-2.909-3.169-5.551-6.457-8.193-9.745l1.07-1.126C316,214.8,318.85,217.6,321.851,220.7Z"
                    fill="#050506"
                />
                <path
                    id="Path_61906"
                    data-name="Path 61906"
                    d="M320.038,293.284c.424.261.5.587.767.969a5,5,0,0,1,.208,1.812c-3.962-3.775-7.923-7.55-11.663-11.648a1.453,1.453,0,0,1,.65-.467C313.205,286.975,316.41,290,320.038,293.284Z"
                    fill="#d8d8d8"
                />
                <path
                    id="Path_61907"
                    data-name="Path 61907"
                    d="M335.011,323.933c3.9,2.895,4.09,5.277.787,8.622-5.416-1.556-.7-5.153-1.425-8.066A1.175,1.175,0,0,1,335.011,323.933Z"
                    fill="#d8d8d8"
                />
                <path
                    id="Path_61908"
                    data-name="Path 61908"
                    d="M338.107,290.931a11.7,11.7,0,0,1,1.607,1.188c.294,3.1.418,6.286-4.057,6.286C333.119,294.964,336.227,293.318,338.107,290.931Z"
                    fill="#080909"
                />
                <path
                    id="Path_61909"
                    data-name="Path 61909"
                    d="M182.4,146c-.142-.493.12-.987.489-1.74,3.1-1.088,6.083-1.939,9.083-2.736a22.346,22.346,0,0,1,4.8-.79C192.269,142.666,187.538,144.332,182.4,146Z"
                    fill="#050506"
                />
                <path
                    id="Path_61910"
                    data-name="Path 61910"
                    d="M322.784,317.618a2.117,2.117,0,0,1-1.609.368,84.491,84.491,0,0,1,.51-9.486,3.1,3.1,0,0,1,2.012-.476A58.927,58.927,0,0,1,322.784,317.618Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61911"
                    data-name="Path 61911"
                    d="M339.963,238.64q-3.407-4.6-6.926-10.276Q336.444,232.958,339.963,238.64Z"
                    fill="#050506"
                />
                <path
                    id="Path_61912"
                    data-name="Path 61912"
                    d="M122.6,257.729c-.983,2.012-1.817,3.688-2.782,5.626-1.759-2.866-.19-7.609,2.152-7.837C122.167,255.5,122.486,256.738,122.6,257.729Z"
                    fill="#050506"
                />
                <path
                    id="Path_61913"
                    data-name="Path 61913"
                    d="M111.962,257.634c-3.713-2.168-5.423-5.588-4.239-10.387A92.7,92.7,0,0,1,111.962,257.634Z"
                    fill="#050506"
                />
                <path
                    id="Path_61914"
                    data-name="Path 61914"
                    d="M257.894,328.971c.2,0,.395,0,.887.032,1.836.619,3.377,1.21,5.119,1.879-3.069,3.576-5.665,1.97-7.818-.695A12.6,12.6,0,0,1,257.894,328.971Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61915"
                    data-name="Path 61915"
                    d="M333.274,249.933a12.077,12.077,0,0,1-2.132-3.6c.9-.772,1.834-1.214,2.811-1.993C337.49,246.181,336.658,248.107,333.274,249.933Z"
                    fill="#050506"
                />
                <path
                    id="Path_61916"
                    data-name="Path 61916"
                    d="M298.669,200.972a4.144,4.144,0,0,1,1.025,2.656c-.386.72-.525,1.042-1.014,1.334a42.216,42.216,0,0,1-3.709-4.042,5.448,5.448,0,0,1,.142-.7A22.48,22.48,0,0,1,298.669,200.972Z"
                    fill="#080909"
                />
                <path
                    id="Path_61917"
                    data-name="Path 61917"
                    d="M348.943,304.11c-.31,1.906-.61,3.751-1.03,6.328-2.85-4.325-2.64-5.684.614-6.431C348.829,304.063,348.952,304.048,348.943,304.11Z"
                    fill="#080909"
                />
                <path
                    id="Path_61918"
                    data-name="Path 61918"
                    d="M279.961,239.647a17.851,17.851,0,0,1-4.544.353c-.35-1.111-.283-2.223-.13-4.782A50.969,50.969,0,0,1,279.961,239.647Z"
                    fill="#060606"
                />
                <path
                    id="Path_61919"
                    data-name="Path 61919"
                    d="M277.5,274.778a8.408,8.408,0,0,1,.9,4.129,36.743,36.743,0,0,1-4.966-3.194C275.4,275.245,276.257,275.042,277.5,274.778Z"
                    fill="#060606"
                />
                <path
                    id="Path_61920"
                    data-name="Path 61920"
                    d="M281.064,252.64c-3.871-.752-1.2-2.621-.327-4.451a11.389,11.389,0,0,1,3.348,2.609c.051.3.163.348.163.348A13.855,13.855,0,0,0,281.064,252.64Z"
                    fill="#060606"
                />
                <path
                    id="Path_61921"
                    data-name="Path 61921"
                    d="M240.715,337.817c-.916-.247-1.537-.4-2.772-.713l3.788-2.973,1.474.99A16.2,16.2,0,0,1,240.715,337.817Z"
                    fill="#070707"
                />
                <path
                    id="Path_61922"
                    data-name="Path 61922"
                    d="M285.269,213.46a6.4,6.4,0,0,1-1.005,1.987l-2.462-4.4,1.394-.874C283.844,211.161,284.493,212.148,285.269,213.46Z"
                    fill="#060606"
                />
                <path
                    id="Path_61923"
                    data-name="Path 61923"
                    d="M182,349.766a6.408,6.408,0,0,1-2.623-.009,1.879,1.879,0,0,1-.377-1.478,19.657,19.657,0,0,0-.694-2.273c1.029,0,1.962,0,3.485.091a2.662,2.662,0,0,1,1.226.91C182.685,347.816,182.357,348.627,182,349.766Z"
                    fill="#050506"
                />
                <path
                    id="Path_61924"
                    data-name="Path 61924"
                    d="M172.4,149a44.366,44.366,0,0,1,7.366-2.271A44.368,44.368,0,0,1,172.4,149Z"
                    fill="#050506"
                />
                <path
                    id="Path_61925"
                    data-name="Path 61925"
                    d="M279.833,174.755a7.69,7.69,0,0,1-1.489,3.192,3.243,3.243,0,0,1-1.324-1.649,5.809,5.809,0,0,1,.734-2.131A3.8,3.8,0,0,1,279.833,174.755Z"
                    fill="#070708"
                />
                <path
                    id="Path_61926"
                    data-name="Path 61926"
                    d="M236.3,108.849a31.657,31.657,0,0,1,3.345-5.81A31.656,31.656,0,0,1,236.3,108.849Z"
                    fill="#050506"
                />
                <path
                    id="Path_61927"
                    data-name="Path 61927"
                    d="M385.73,251.229a21.519,21.519,0,0,1-1.378,5.716A21.518,21.518,0,0,1,385.73,251.229Z"
                    fill="#070707"
                />
                <path
                    id="Path_61928"
                    data-name="Path 61928"
                    d="M296.021,301.255c.083-1.236.213-2.142.382-3.325,1.032.363,1.862.654,2.985,1.108a3.954,3.954,0,0,1-1.1,2.512C297.826,301.914,296.827,301.6,296.021,301.255Z"
                    fill="#060606"
                />
                <path
                    id="Path_61929"
                    data-name="Path 61929"
                    d="M329.127,235.3c2.114-.161,4.434-.1,3.138,3.487A16.516,16.516,0,0,1,329.127,235.3Z"
                    fill="#050506"
                />
                <path
                    id="Path_61930"
                    data-name="Path 61930"
                    d="M182.41,336.985c-2.5-3.13.15-2.693,2.214-2.993A8.1,8.1,0,0,1,182.41,336.985Z"
                    fill="#070707"
                />
                <path
                    id="Path_61931"
                    data-name="Path 61931"
                    d="M334.981,339.993h3.506l-4.161,5.051a7.666,7.666,0,0,1-.184-2.89A23.065,23.065,0,0,0,334.981,339.993Z"
                    fill="#202020"
                />
                <path
                    id="Path_61932"
                    data-name="Path 61932"
                    d="M308.456,315.614a7.106,7.106,0,0,1-.318-2.4l2.382,1.2A6.605,6.605,0,0,1,308.456,315.614Z"
                    fill="#060606"
                />
                <path
                    id="Path_61933"
                    data-name="Path 61933"
                    d="M251.327,304a38.58,38.58,0,0,1,1.187-6.751,51.954,51.954,0,0,1,1.388,6.4A6.084,6.084,0,0,1,251.327,304Z"
                    fill="#070707"
                />
                <path
                    id="Path_61934"
                    data-name="Path 61934"
                    d="M309.959,283.6c.041.349-.387.493-.611.47-1.24-.537-2.255-1.051-3.27-1.564l.866-1.5A22.212,22.212,0,0,1,309.959,283.6Z"
                    fill="#060606"
                />
                <path
                    id="Path_61935"
                    data-name="Path 61935"
                    d="M240,346a33.136,33.136,0,0,1,4.583.249.938.938,0,0,1,.469.68,1.03,1.03,0,0,1-.295.194A1.5,1.5,0,0,0,244,348a9.3,9.3,0,0,1-3.8-.124A7.6,7.6,0,0,1,240,346Z"
                    fill="#050506"
                />
                <path
                    id="Path_61936"
                    data-name="Path 61936"
                    d="M333.353,306.305a9.216,9.216,0,0,1-.872,3.865,4.337,4.337,0,0,1-1.357-1.887A7.424,7.424,0,0,1,333.353,306.305Z"
                    fill="#080909"
                />
                <path
                    id="Path_61937"
                    data-name="Path 61937"
                    d="M299.954,269.77a23.7,23.7,0,0,1-3.041-4.378A23.7,23.7,0,0,1,299.954,269.77Z"
                    fill="#060606"
                />
                <path
                    id="Path_61938"
                    data-name="Path 61938"
                    d="M153.762,340a14.911,14.911,0,0,1,.21,3.608,5.671,5.671,0,0,1-2.689-2.441,9.161,9.161,0,0,1,1.727-1.281C153.177,339.909,153.344,339.934,153.762,340Z"
                    fill="#070707"
                />
                <path
                    id="Path_61939"
                    data-name="Path 61939"
                    d="M271.005,250.367a23.66,23.66,0,0,1,2.957,4.275A23.663,23.663,0,0,1,271.005,250.367Z"
                    fill="#060606"
                />
                <path
                    id="Path_61940"
                    data-name="Path 61940"
                    d="M342.995,243.636a14.535,14.535,0,0,1-2.962-3.29A14.532,14.532,0,0,1,342.995,243.636Z"
                    fill="#050506"
                />
                <path
                    id="Path_61941"
                    data-name="Path 61941"
                    d="M245.5,328.011a13.933,13.933,0,0,1,3.652-.64l-.047,1.581A14.442,14.442,0,0,1,245.5,328.011Z"
                    fill="#070707"
                />
                <path
                    id="Path_61942"
                    data-name="Path 61942"
                    d="M262.109,336.113l-3.787,1.894-.551-1.65c1.149-.132,2.3-.264,3.852-.364C262.029,336.025,262.109,336.113,262.109,336.113Z"
                    fill="#070707"
                />
                <path
                    id="Path_61943"
                    data-name="Path 61943"
                    d="M287.541,220.627a18.169,18.169,0,0,1,1.162,2.695l-1.7.129A9.632,9.632,0,0,1,287.541,220.627Z"
                    fill="#060606"
                />
                <path
                    id="Path_61944"
                    data-name="Path 61944"
                    d="M152.968,339.565a4.324,4.324,0,0,1-1.672,1.3,12.088,12.088,0,0,1-1.006-3.018l.67-.637A18.125,18.125,0,0,1,152.968,339.565Z"
                    fill="#050506"
                />
                <path
                    id="Path_61945"
                    data-name="Path 61945"
                    d="M338.2,306.7a4.817,4.817,0,0,1-1.758-.7,6.822,6.822,0,0,1,.664-1.738,6.468,6.468,0,0,1,2.368.254C339.107,305.161,338.743,305.806,338.2,306.7Z"
                    fill="#080909"
                />
                <path
                    id="Path_61946"
                    data-name="Path 61946"
                    d="M158.468,348.018a2.4,2.4,0,0,1-.4-1.742,7.342,7.342,0,0,1,2.756-.131A14.788,14.788,0,0,1,158.468,348.018Z"
                    fill="#070707"
                />
                <path
                    id="Path_61947"
                    data-name="Path 61947"
                    d="M326.386,302a8.318,8.318,0,0,1,.214-3.2,23.3,23.3,0,0,1,2.077,2.9A5.145,5.145,0,0,1,326.386,302Z"
                    fill="#080909"
                />
                <path
                    id="Path_61948"
                    data-name="Path 61948"
                    d="M277.881,349.606a18.579,18.579,0,0,1-3.454.428,2.52,2.52,0,0,1,.592-2.013,3.861,3.861,0,0,1,1.718.08A5.553,5.553,0,0,1,277.881,349.606Z"
                    fill="#070707"
                />
                <path
                    id="Path_61949"
                    data-name="Path 61949"
                    d="M162.282,315.967c-3.314-2.426.982-1.724,1.3-3.038A6.236,6.236,0,0,1,162.282,315.967Z"
                    fill="#070707"
                />
                <path
                    id="Path_61950"
                    data-name="Path 61950"
                    d="M183.3,346.862a2.746,2.746,0,0,1-1.159-.789,3.27,3.27,0,0,1-.035-1.754,6.688,6.688,0,0,1,2.515.509A12.025,12.025,0,0,1,183.3,346.862Z"
                    fill="#070707"
                />
                <path
                    id="Path_61951"
                    data-name="Path 61951"
                    d="M270.993,315.654a11.966,11.966,0,0,1,2.731,1.736c-.668.2-1.336.408-2.349.652A4.876,4.876,0,0,1,270.993,315.654Z"
                    fill="#070707"
                />
                <path
                    id="Path_61952"
                    data-name="Path 61952"
                    d="M212.858,321.528a10.593,10.593,0,0,1,2.212,1.719,9.409,9.409,0,0,1-1.893.732A5.16,5.16,0,0,1,212.858,321.528Z"
                    fill="#070707"
                />
                <path
                    id="Path_61953"
                    data-name="Path 61953"
                    d="M225.824,319.2c-1.059.14-2.055-.207-3.79-.812a38.806,38.806,0,0,1,3.506-2.518A7.666,7.666,0,0,1,225.824,319.2Z"
                    fill="#050506"
                />
                <path
                    id="Path_61954"
                    data-name="Path 61954"
                    d="M272.076,331.739c1.075.036,2.04.389,4.47,1.278-2.536.488-3.639.7-5.138.86A4.153,4.153,0,0,1,272.076,331.739Z"
                    fill="#070707"
                />
                <path
                    id="Path_61955"
                    data-name="Path 61955"
                    d="M107,240.662a5.457,5.457,0,0,1-1.253-2.463A5.457,5.457,0,0,1,107,240.662Z"
                    fill="#050506"
                />
                <path
                    id="Path_61956"
                    data-name="Path 61956"
                    d="M271.093,247.192a1.735,1.735,0,0,1-.072-.956,8.787,8.787,0,0,1,2.616-.235,3.46,3.46,0,0,1-1.319,1.959A2.106,2.106,0,0,1,271.093,247.192Z"
                    fill="#060606"
                />
                <path
                    id="Path_61957"
                    data-name="Path 61957"
                    d="M323.724,323.3a4.454,4.454,0,0,1-.114-3.19A4.455,4.455,0,0,1,323.724,323.3Z"
                    fill="#080909"
                />
                <path
                    id="Path_61958"
                    data-name="Path 61958"
                    d="M240.7,309.245a6.416,6.416,0,0,1,2.822,1.686A6.415,6.415,0,0,1,240.7,309.245Z"
                    fill="#070707"
                />
                <path
                    id="Path_61959"
                    data-name="Path 61959"
                    d="M120.64,239c.281-2.556,1.372-2.535,2.92-.289A8.591,8.591,0,0,1,120.64,239Z"
                    fill="#050506"
                />
                <path
                    id="Path_61960"
                    data-name="Path 61960"
                    d="M321,296.033a3.6,3.6,0,0,0-.257-1.722c1.737-3.136,2.2-.162,3.112,1.168-.4.55-.639.6-.882.64a2.783,2.783,0,0,1-.73-.395,1.4,1.4,0,0,0-1.319.256S320.992,296,321,296.033Z"
                    fill="#060606"
                />
                <path
                    id="Path_61961"
                    data-name="Path 61961"
                    d="M202.748,302.009a16.99,16.99,0,0,1,1.782-3.236c.391.424.427.937.47,2.082.007.632.018,1.124.018,1.124a1.412,1.412,0,0,1-.4.023C203.743,302.007,203.245,302.008,202.748,302.009Z"
                    fill="#050506"
                />
                <path
                    id="Path_61962"
                    data-name="Path 61962"
                    d="M155.04,351.363a5.819,5.819,0,0,1,2.583-.364A5.819,5.819,0,0,1,155.04,351.363Z"
                    fill="#070707"
                />
                <path
                    id="Path_61963"
                    data-name="Path 61963"
                    d="M287.357,325.972a5.049,5.049,0,0,1,.243-3.07A5.049,5.049,0,0,1,287.357,325.972Z"
                    fill="#070707"
                />
                <path
                    id="Path_61964"
                    data-name="Path 61964"
                    d="M315.513,334.951a4.051,4.051,0,0,1,1.276-2.269A4.051,4.051,0,0,1,315.513,334.951Z"
                    fill="#070707"
                />
                <path
                    id="Path_61965"
                    data-name="Path 61965"
                    d="M156.927,330.035c-1.259.155-3.8,1.009-1.791-2.115A4.468,4.468,0,0,1,156.927,330.035Z"
                    fill="#070707"
                />
                <path
                    id="Path_61966"
                    data-name="Path 61966"
                    d="M187.138,339.36a3.076,3.076,0,0,1-1.174,1.242,7.758,7.758,0,0,1-.525-.639A4.445,4.445,0,0,1,187.138,339.36Z"
                    fill="#070707"
                />
                <path
                    id="Path_61967"
                    data-name="Path 61967"
                    d="M263.965,312.688a7.36,7.36,0,0,1-.4-2.917A7.359,7.359,0,0,1,263.965,312.688Z"
                    fill="#070707"
                />
                <path
                    id="Path_61968"
                    data-name="Path 61968"
                    d="M263.015,316.585a6.719,6.719,0,0,1-2.213-1.128,6.416,6.416,0,0,1,1.831-1.377A5.389,5.389,0,0,1,263.015,316.585Z"
                    fill="#070707"
                />
                <path
                    id="Path_61969"
                    data-name="Path 61969"
                    d="M290.3,316.888a14.19,14.19,0,0,1,.8-2.858,4.51,4.51,0,0,1,.914,1.593A4.715,4.715,0,0,1,290.3,316.888Z"
                    fill="#070707"
                />
                <path
                    id="Path_61970"
                    data-name="Path 61970"
                    d="M185,316.63a11.791,11.791,0,0,1-3.862-1.1,29.9,29.9,0,0,1,3.5-.742A2.88,2.88,0,0,1,185,316.63Z"
                    fill="#070707"
                />
                <path
                    id="Path_61971"
                    data-name="Path 61971"
                    d="M199,335.675a2.581,2.581,0,0,1-.05-1.455l1.256.216A4.444,4.444,0,0,1,199,335.675Z"
                    fill="#070707"
                />
                <path
                    id="Path_61972"
                    data-name="Path 61972"
                    d="M241.933,374.775a5.479,5.479,0,0,1-2.7-1.451A5.479,5.479,0,0,1,241.933,374.775Z"
                    fill="#070707"
                />
                <path
                    id="Path_61973"
                    data-name="Path 61973"
                    d="M258.184,247.9a2.945,2.945,0,0,1,.715-1.144l.588,1.574A2.748,2.748,0,0,1,258.184,247.9Z"
                    fill="#060606"
                />
                <path
                    id="Path_61974"
                    data-name="Path 61974"
                    d="M173.126,331.2a4.837,4.837,0,0,1,1.974,1.965A4.837,4.837,0,0,1,173.126,331.2Z"
                    fill="#070707"
                />
                <path
                    id="Path_61975"
                    data-name="Path 61975"
                    d="M199.054,387.209a3.478,3.478,0,0,1,1.821,1.5A3.479,3.479,0,0,1,199.054,387.209Z"
                    fill="#070707"
                />
                <path
                    id="Path_61976"
                    data-name="Path 61976"
                    d="M232.915,378.2a6.7,6.7,0,0,1-.52,2.832A6.7,6.7,0,0,1,232.915,378.2Z"
                    fill="#070707"
                />
                <path
                    id="Path_61977"
                    data-name="Path 61977"
                    d="M273.372,265.7a15.01,15.01,0,0,1-1.855-3.125,1.482,1.482,0,0,1,.6-.7,8.654,8.654,0,0,1,1.839,2.821A3.2,3.2,0,0,1,273.372,265.7Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_61978"
                    data-name="Path 61978"
                    d="M249.963,312.768a5.9,5.9,0,0,1-1.407-2.678A5.9,5.9,0,0,1,249.963,312.768Z"
                    fill="#070707"
                />
                <path
                    id="Path_61979"
                    data-name="Path 61979"
                    d="M277.5,372.211a8.01,8.01,0,0,1,1.74-1.73l.426.674A8.193,8.193,0,0,1,277.5,372.211Z"
                    fill="#070707"
                />
                <path
                    id="Path_61980"
                    data-name="Path 61980"
                    d="M331.169,289.237A5.953,5.953,0,0,1,333.662,288,5.953,5.953,0,0,1,331.169,289.237Z"
                    fill="#060606"
                />
                <path
                    id="Path_61981"
                    data-name="Path 61981"
                    d="M184.533,326.287a7.729,7.729,0,0,1,.14-3.4A7.729,7.729,0,0,1,184.533,326.287Z"
                    fill="#050506"
                />
                <path
                    id="Path_61982"
                    data-name="Path 61982"
                    d="M240,298.446a4.142,4.142,0,0,1,1.989.3,9.736,9.736,0,0,1-1.646,1.978A4.439,4.439,0,0,1,240,298.446Z"
                    fill="#070707"
                />
                <path
                    id="Path_61983"
                    data-name="Path 61983"
                    d="M306.977,348.7a3.588,3.588,0,0,1-1.205-2.6,6.507,6.507,0,0,1,1.22-.09C306.989,346.782,306.988,347.551,306.977,348.7Z"
                    fill="#050506"
                />
                <path
                    id="Path_61984"
                    data-name="Path 61984"
                    d="M212,299.359a5.461,5.461,0,0,1,.313,2.418A5.461,5.461,0,0,1,212,299.359Z"
                    fill="#070707"
                />
                <path
                    id="Path_61985"
                    data-name="Path 61985"
                    d="M335.139,323.649c-.128.284-.587.439-.819.509a12.8,12.8,0,0,1,.706-2.73A11.524,11.524,0,0,1,335.139,323.649Z"
                    fill="#080909"
                />
                <path
                    id="Path_61986"
                    data-name="Path 61986"
                    d="M221.216,338.924a2.584,2.584,0,0,1-.884-1.3,4.852,4.852,0,0,1,1.985-.027A4.08,4.08,0,0,1,221.216,338.924Z"
                    fill="#070707"
                />
                <path
                    id="Path_61987"
                    data-name="Path 61987"
                    d="M334.7,340.025a2.509,2.509,0,0,1-.552,1.789A2.509,2.509,0,0,1,334.7,340.025Z"
                    fill="#080909"
                />
                <path
                    id="Path_61988"
                    data-name="Path 61988"
                    d="M239.7,346.036a2.505,2.505,0,0,1,.281,1.641,2.719,2.719,0,0,1-1.572-.389A5.8,5.8,0,0,1,239.7,346.036Z"
                    fill="#070707"
                />
                <path
                    id="Path_61989"
                    data-name="Path 61989"
                    d="M262.032,354.759a5.862,5.862,0,0,1-1.727-.273l.24-.744A4.646,4.646,0,0,1,262.032,354.759Z"
                    fill="#070707"
                />
                <path
                    id="Path_61990"
                    data-name="Path 61990"
                    d="M299.1,355.077a4,4,0,0,1,.3,2.326A4,4,0,0,1,299.1,355.077Z"
                    fill="#070707"
                />
                <path
                    id="Path_61991"
                    data-name="Path 61991"
                    d="M312.33,357.954a4.1,4.1,0,0,1,1.244-2.136A4.1,4.1,0,0,1,312.33,357.954Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_61992"
                    data-name="Path 61992"
                    d="M254.721,411.2a2.6,2.6,0,0,1-.366,1.887A2.6,2.6,0,0,1,254.721,411.2Z"
                    fill="#070707"
                />
                <path
                    id="Path_61993"
                    data-name="Path 61993"
                    d="M271.284,417.928a4.6,4.6,0,0,1,1.179,1.408l-.653.349A5.379,5.379,0,0,1,271.284,417.928Z"
                    fill="#070707"
                />
                <path
                    id="Path_61994"
                    data-name="Path 61994"
                    d="M208.007,284.9a3.752,3.752,0,0,1,.507-1.923,5.141,5.141,0,0,1,1.371,1.643A2.714,2.714,0,0,1,208.007,284.9Z"
                    fill="#070707"
                />
                <path
                    id="Path_61995"
                    data-name="Path 61995"
                    d="M202.682,302.355a3.26,3.26,0,0,1,1.931-.343,3.1,3.1,0,0,1-1.161,1.942A2.159,2.159,0,0,1,202.682,302.355Z"
                    fill="#070707"
                />
                <path
                    id="Path_61996"
                    data-name="Path 61996"
                    d="M345.959,249.679a3.887,3.887,0,0,1-1.917-1.358A3.887,3.887,0,0,1,345.959,249.679Z"
                    fill="#050506"
                />
                <path
                    id="Path_61997"
                    data-name="Path 61997"
                    d="M338.607,311.948a2.06,2.06,0,0,1-.085-1.893A2.06,2.06,0,0,1,338.607,311.948Z"
                    fill="#060606"
                />
                <path
                    id="Path_61998"
                    data-name="Path 61998"
                    d="M186.327,313.949a3.74,3.74,0,0,1,1.227-2.143A3.739,3.739,0,0,1,186.327,313.949Z"
                    fill="#070707"
                />
                <path
                    id="Path_61999"
                    data-name="Path 61999"
                    d="M107.979,244.7a2.854,2.854,0,0,1-1.208-1.531A2.854,2.854,0,0,1,107.979,244.7Z"
                    fill="#050506"
                />
                <path
                    id="Path_62000"
                    data-name="Path 62000"
                    d="M275.712,266.759c-.2.423-.4.626-.639,1.086a8.291,8.291,0,0,1-1.554-1.9c-.009-.4.129-.558.484-.936A4.367,4.367,0,0,1,275.712,266.759Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62001"
                    data-name="Path 62001"
                    d="M271.784,321.159a2.617,2.617,0,0,1-.461,1.968A2.617,2.617,0,0,1,271.784,321.159Z"
                    fill="#070707"
                />
                <path
                    id="Path_62002"
                    data-name="Path 62002"
                    d="M271.042,327.367a3.327,3.327,0,0,1,1.627,1.606A3.327,3.327,0,0,1,271.042,327.367Z"
                    fill="#070707"
                />
                <path
                    id="Path_62003"
                    data-name="Path 62003"
                    d="M266.381,257.642a8.113,8.113,0,0,1-1.846-2.1,1.391,1.391,0,0,1,.576-.662,5.863,5.863,0,0,1,1.714,1.916A2.078,2.078,0,0,1,266.381,257.642Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62004"
                    data-name="Path 62004"
                    d="M227.344,301a1.414,1.414,0,0,1-.736-.684,8.262,8.262,0,0,1,2.331.4C228.619,300.979,228.156,300.99,227.344,301Z"
                    fill="#070707"
                />
                <path
                    id="Path_62005"
                    data-name="Path 62005"
                    d="M273.568,345c.316.17.335.34.363.766a5.9,5.9,0,0,1-2.119.1l-.038-.531C272.272,345.223,272.772,345.11,273.568,345Z"
                    fill="#070707"
                />
                <path
                    id="Path_62006"
                    data-name="Path 62006"
                    d="M257.892,345.642a1.866,1.866,0,0,1,1.1-.453c.072-.01.177.225.267.348A3.253,3.253,0,0,1,257.892,345.642Z"
                    fill="#070707"
                />
                <path
                    id="Path_62007"
                    data-name="Path 62007"
                    d="M257.886,328.637a3.455,3.455,0,0,1-1.661,1.162c-.245-.29-.232-.618-.233-1.192A2.171,2.171,0,0,1,257.886,328.637Z"
                    fill="#070707"
                />
                <path
                    id="Path_62008"
                    data-name="Path 62008"
                    d="M322.978,296.142c.242-.068.485-.112,1.094-.223a3.125,3.125,0,0,1,.587,1.738,6.992,6.992,0,0,1-1.563-1.135C322.966,296.21,322.979,296.165,322.978,296.142Z"
                    fill="#070708"
                />
                <path
                    id="Path_62009"
                    data-name="Path 62009"
                    d="M173.02,328.283a3.875,3.875,0,0,1,2.257.057c-.776.622-1.257,1.007-1.989,1.576C173.029,329.615,173.02,329.131,173.02,328.283Z"
                    fill="#070707"
                />
                <path
                    id="Path_62010"
                    data-name="Path 62010"
                    d="M272.643,206.741a1.651,1.651,0,0,1,1.02-.091l-.264.737A2.408,2.408,0,0,1,272.643,206.741Z"
                    fill="#060606"
                />
                <path
                    id="Path_62011"
                    data-name="Path 62011"
                    d="M222.463,383.985a4.727,4.727,0,0,1-.546-2.135,15.431,15.431,0,0,1,1.475,1.728C223.288,383.924,223.053,383.947,222.463,383.985Z"
                    fill="#070707"
                />
                <path
                    id="Path_62012"
                    data-name="Path 62012"
                    d="M336.741,350.361a1.665,1.665,0,0,1-.092-1.028l.743.266A2.429,2.429,0,0,1,336.741,350.361Z"
                    fill="#070707"
                />
                <path
                    id="Path_62013"
                    data-name="Path 62013"
                    d="M136.262,261.107a2.866,2.866,0,0,1,1.779.534A2.866,2.866,0,0,1,136.262,261.107Z"
                    fill="#050506"
                />
                <path
                    id="Path_62014"
                    data-name="Path 62014"
                    d="M268.481,259.683c-.584-.522-1.168-1.044-1.926-1.8-.058-.366.058-.494.362-.8a3.531,3.531,0,0,1,1.922,1.735A2.3,2.3,0,0,1,268.481,259.683Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62015"
                    data-name="Path 62015"
                    d="M230.815,264.694a4.633,4.633,0,0,1-1.449,2.316c-.352-.16-.383-.427-.466-1.095A2.527,2.527,0,0,1,230.815,264.694Z"
                    fill="#060606"
                />
                <path
                    id="Path_62016"
                    data-name="Path 62016"
                    d="M215.025,317.015c-.133.369-.587.731-1.4,1.107C213.75,317.76,214.227,317.383,215.025,317.015Z"
                    fill="#070707"
                />
                <path
                    id="Path_62017"
                    data-name="Path 62017"
                    d="M281.989,381.243a.547.547,0,0,1,0,.505A.547.547,0,0,1,281.989,381.243Z"
                    fill="#070707"
                />
                <path
                    id="Path_62018"
                    data-name="Path 62018"
                    d="M297.5,357.247c.17.246.044.4-.361.65a2.725,2.725,0,0,1-1.183-.575A7.271,7.271,0,0,1,297.5,357.247Z"
                    fill="#070707"
                />
                <path
                    id="Path_62019"
                    data-name="Path 62019"
                    d="M345.011,278.758a.549.549,0,0,1,0-.507A.549.549,0,0,1,345.011,278.758Z"
                    fill="#080909"
                />
                <path
                    id="Path_62020"
                    data-name="Path 62020"
                    d="M254,387.252a2.842,2.842,0,0,1,.381,1.818C254.053,388.679,254.028,388.16,254,387.252Z"
                    fill="#070707"
                />
                <path
                    id="Path_62021"
                    data-name="Path 62021"
                    d="M138,272.471a2.087,2.087,0,0,1,.361,1.542C138.033,273.685,138.018,273.243,138,272.471Z"
                    fill="#050506"
                />
                <path
                    id="Path_62022"
                    data-name="Path 62022"
                    d="M281.234,371.011a.562.562,0,0,1,.519,0A.562.562,0,0,1,281.234,371.011Z"
                    fill="#070707"
                />
                <path
                    id="Path_62023"
                    data-name="Path 62023"
                    d="M265.009,217.766a.562.562,0,0,1,0-.519A.562.562,0,0,1,265.009,217.766Z"
                    fill="#060606"
                />
                <path
                    id="Path_62024"
                    data-name="Path 62024"
                    d="M272.046,399.187a2.682,2.682,0,0,1,.267,1.751C272.024,400.566,272.022,400.064,272.046,399.187Z"
                    fill="#070707"
                />
                <path
                    id="Path_62025"
                    data-name="Path 62025"
                    d="M317.759,344.989a.549.549,0,0,1-.508,0A.549.549,0,0,1,317.759,344.989Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_62026"
                    data-name="Path 62026"
                    d="M204.995,292.692a2.353,2.353,0,0,1-.237-1.515C205,291.46,205,291.908,204.995,292.692Z"
                    fill="#070707"
                />
                <path
                    id="Path_62027"
                    data-name="Path 62027"
                    d="M187.355,345.261a.777.777,0,0,1,.286-.529A.777.777,0,0,1,187.355,345.261Z"
                    fill="#070707"
                />
                <path
                    id="Path_62028"
                    data-name="Path 62028"
                    d="M261.994,335.977a12.139,12.139,0,0,1,1.366-.407,6.451,6.451,0,0,1-1.015.5C262.109,336.113,262.029,336.025,261.994,335.977Z"
                    fill="#070707"
                />
                <path
                    id="Path_62029"
                    data-name="Path 62029"
                    d="M213.874,348.15a2.885,2.885,0,0,1-.239-1.995A2.885,2.885,0,0,1,213.874,348.15Z"
                    fill="#070707"
                />
                <path
                    id="Path_62030"
                    data-name="Path 62030"
                    d="M318.385,325.036a2.265,2.265,0,0,1,.6-.93c.212.254.425.508.353.835A5.316,5.316,0,0,1,318.385,325.036Z"
                    fill="#070707"
                />
                <path
                    id="Path_62031"
                    data-name="Path 62031"
                    d="M265.259,299.99a3.967,3.967,0,0,1,.215-1.87,8,8,0,0,1,.656,1.463C265.969,299.95,265.766,299.965,265.259,299.99Z"
                    fill="#070707"
                />
                <path
                    id="Path_62032"
                    data-name="Path 62032"
                    d="M300.032,349.23a2.52,2.52,0,0,1,.305,1.731C300.017,350.566,300.016,350.08,300.032,349.23Z"
                    fill="#050506"
                />
                <path
                    id="Path_62033"
                    data-name="Path 62033"
                    d="M222.983,325.626a2.489,2.489,0,0,1-1.415-.231,7.1,7.1,0,0,1,1.064-.559C222.927,324.957,222.946,325.148,222.983,325.626Z"
                    fill="#070707"
                />
                <path
                    id="Path_62034"
                    data-name="Path 62034"
                    d="M244.009,398.414a1.729,1.729,0,0,1-.307-1.293A1.729,1.729,0,0,1,244.009,398.414Z"
                    fill="#070707"
                />
                <path
                    id="Path_62035"
                    data-name="Path 62035"
                    d="M256.043,326.083a4.877,4.877,0,0,1,1.829.508,5.551,5.551,0,0,1-1.53.324C256.006,326.671,256.013,326.5,256.043,326.083Z"
                    fill="#070707"
                />
                <path
                    id="Path_62036"
                    data-name="Path 62036"
                    d="M217,244.376a.458.458,0,0,1,.3.589C217,245,217,244.583,217,244.376Z"
                    fill="#0a0a0a"
                />
                <path
                    id="Path_62037"
                    data-name="Path 62037"
                    d="M242.362,407.826c-.129-.186-.061-.535.267-1C242.779,407.029,242.67,407.347,242.362,407.826Z"
                    fill="#050506"
                />
                <path
                    id="Path_62038"
                    data-name="Path 62038"
                    d="M126.117,242.446c.182-.1.456-.047.7.272C126.556,242.908,126.364,242.779,126.117,242.446Z"
                    fill="#050506"
                />
                <path
                    id="Path_62039"
                    data-name="Path 62039"
                    d="M268.93,259.1c.454-.024.746.138.951.758a3.388,3.388,0,0,1-.346.909,10.775,10.775,0,0,1-.906-.872C268.481,259.683,268.768,259.282,268.93,259.1Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62040"
                    data-name="Path 62040"
                    d="M277.032,183.965a2.919,2.919,0,0,1,1.024.641c-.06.361-.2.473-.588.718-.465-.029-.657-.225-.763-.771A1.266,1.266,0,0,1,277.032,183.965Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_62041"
                    data-name="Path 62041"
                    d="M285.042,251.969a.91.91,0,0,1-.755-.616c-.038-.207-.15-.26-.129-.2a2.178,2.178,0,0,1,.947.659C284.989,252.027,285.042,251.969,285.042,251.969Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62042"
                    data-name="Path 62042"
                    d="M254.72,408.073c.236.142.326.345.12.7C254.287,408.642,254.3,408.378,254.72,408.073Z"
                    fill="#050506"
                />
                <path
                    id="Path_62043"
                    data-name="Path 62043"
                    d="M285.975,252.973c-.458.006-.734-.221-.972-.726.038-.278-.014-.22-.03-.184a2.72,2.72,0,0,1,1.264-.041C286.371,252.41,286.264,252.575,285.975,252.973Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62044"
                    data-name="Path 62044"
                    d="M193.468,388.769c-.168-.174-.16-.551.1-1.088C193.768,387.869,193.706,388.217,193.468,388.769Z"
                    fill="#050506"
                />
                <path
                    id="Path_62045"
                    data-name="Path 62045"
                    d="M263.547,254.786c.086-.514.171-1.027.253-1A2.4,2.4,0,0,1,263.547,254.786Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62046"
                    data-name="Path 62046"
                    d="M260.953,399.827c-.2-.041-.389-.429-.306-.93C260.935,399.016,260.955,399.248,260.953,399.827Z"
                    fill="#050506"
                />
                <path
                    id="Path_62047"
                    data-name="Path 62047"
                    d="M263.952,254.109a1.164,1.164,0,0,1,1.085.528c-.085.34-.244.435-.666.623a.669.669,0,0,1-.762-.352A1.543,1.543,0,0,1,263.952,254.109Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62048"
                    data-name="Path 62048"
                    d="M219.963,396.914a.664.664,0,0,1-.272-.775C220,396.189,219.985,396.673,219.963,396.914Z"
                    fill="#070707"
                />
                <path
                    id="Path_62049"
                    data-name="Path 62049"
                    d="M312.218,308.782a2.138,2.138,0,0,1,.564.926,1.209,1.209,0,0,1-.872-.251C311.813,309.189,312.083,308.917,312.218,308.782Z"
                    fill="#eee"
                />
                <path
                    id="Path_62050"
                    data-name="Path 62050"
                    d="M300.044,344.038a.9.9,0,0,1,.681.388.758.758,0,0,1-.5.321C300,344.706,300.016,344.259,300.044,344.038Z"
                    fill="#070707"
                />
                <path id="Path_62051" data-name="Path 62051" d="M260.533,343.551Z" fill="#070707" />
                <path id="Path_62052" data-name="Path 62052" d="M255.537,343.557Z" fill="#070707" />
                <path
                    id="Path_62053"
                    data-name="Path 62053"
                    d="M333.869,303.605a.742.742,0,0,1-.909-.291C333.306,303.066,333.551,303.207,333.869,303.605Z"
                    fill="#080909"
                />
                <path
                    id="Path_62054"
                    data-name="Path 62054"
                    d="M223.96,304.853a.75.75,0,0,1-.281-.883C223.973,304.124,223.979,304.333,223.96,304.853Z"
                    fill="#070707"
                />
                <path
                    id="Path_62055"
                    data-name="Path 62055"
                    d="M211.992,306.19a1.256,1.256,0,0,1,.746.237.793.793,0,0,1-.516.325C211.994,306.712,211.99,306.364,211.992,306.19Z"
                    fill="#070707"
                />
                <path
                    id="Path_62056"
                    data-name="Path 62056"
                    d="M181.012,340.519c-.154.189-.321.281-.449.244s-.3-.206-.3-.316.19-.221.527-.36C181.02,340.059,181.017,340.366,181.012,340.519Z"
                    fill="#070707"
                />
                <path
                    id="Path_62057"
                    data-name="Path 62057"
                    d="M307,345.832c-.2.174-.4.166-.88.128-.07-.323.151-.615.632-.789C307.012,345.288,307.007,345.651,307,345.832Z"
                    fill="#0d0d0d"
                />
                <path id="Path_62058" data-name="Path 62058" d="M333.555,338.462Z" fill="#0d0d0d" />
                <path
                    id="Path_62059"
                    data-name="Path 62059"
                    d="M333.657,315.1c.07.2-.034.494-.392.743C333.109,315.548,333.266,315.345,333.657,315.1Z"
                    fill="#080909"
                />
                <path
                    id="Path_62060"
                    data-name="Path 62060"
                    d="M217.9,336.67c-.223.076-.538-.026-.785-.393C217.44,336.108,217.649,336.268,217.9,336.67Z"
                    fill="#070707"
                />
                <path
                    id="Path_62061"
                    data-name="Path 62061"
                    d="M217.386,333.883c-.1-.2-.025-.5.329-.787C217.914,333.378,217.769,333.6,217.386,333.883Z"
                    fill="#070707"
                />
                <path id="Path_62062" data-name="Path 62062" d="M200.466,331.448Z" fill="#070707" />
                <path
                    id="Path_62063"
                    data-name="Path 62063"
                    d="M181.437,356.609c-.234-.168-.078-.448.043-.552A.352.352,0,0,1,181.437,356.609Z"
                    fill="#070707"
                />
                <path
                    id="Path_62064"
                    data-name="Path 62064"
                    d="M271.351,262.277c-.543-.05-.793-.23-.857-.767a2.092,2.092,0,0,1,.614-.624,3.321,3.321,0,0,1,.934.744C271.954,261.974,271.789,262.075,271.351,262.277Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62065"
                    data-name="Path 62065"
                    d="M275.5,210.335a1.78,1.78,0,0,1-.277-1.1,1.251,1.251,0,0,1,.813.368C275.99,209.984,275.857,210.095,275.5,210.335Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_62066"
                    data-name="Path 62066"
                    d="M276.616,184.366a2.641,2.641,0,0,1-.817-.916,1.635,1.635,0,0,1,1.16.206C277.032,183.965,276.759,184.236,276.616,184.366Z"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_62067"
                    data-name="Path 62067"
                    d="M261.082,366.057c-.14.006-.28.012-.247-.022A.29.29,0,0,1,261.082,366.057Z"
                    fill="#070707"
                />
                <path id="Path_62068" data-name="Path 62068" d="M256.462,366.442Z" fill="#070707" />
                <path
                    id="Path_62069"
                    data-name="Path 62069"
                    d="M260.975,365.956c.1-.042.237-.047.239.024A.171.171,0,0,1,260.975,365.956Z"
                    fill="#070707"
                />
                <path
                    id="Path_62070"
                    data-name="Path 62070"
                    d="M270.414,261.293a.729.729,0,0,1-.805-.394,1.372,1.372,0,0,1,.341-.793,1.18,1.18,0,0,1,1.085.536C270.958,260.985,270.808,261.084,270.414,261.293Z"
                    fill="#e2e2e2"
                />
                <path
                    id="Path_62071"
                    data-name="Path 62071"
                    d="M309.009,351.566a.412.412,0,0,1-.287-.539C308.986,350.965,309.008,351.366,309.009,351.566Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_62072"
                    data-name="Path 62072"
                    d="M229.982,296.718c-.191-.025-.387-.371-.331-.837C229.928,295.972,229.953,296.185,229.982,296.718Z"
                    fill="#070707"
                />
                <path
                    id="Path_62073"
                    data-name="Path 62073"
                    d="M321.046,296.36c.15-.58.42-.779,1.1-.681C322.086,296.232,321.626,296.486,321.046,296.36Z"
                    fill="#d8d8d8"
                />
                <path
                    id="Path_62074"
                    data-name="Path 62074"
                    d="M244.208,347.9c-.12-.212.054-.461.522-.744C244.862,347.379,244.689,347.626,244.208,347.9Z"
                    fill="#070707"
                />
                <path
                    id="Path_62075"
                    data-name="Path 62075"
                    d="M245.218,346.855c-.165.074-.208-.371-.218-.595C245.121,346.285,245.252,346.532,245.218,346.855Z"
                    fill="#070707"
                />
                <path
                    id="Path_62076"
                    data-name="Path 62076"
                    d="M349.01,299.245a.635.635,0,0,1,.312.775C349.027,299.909,349.016,299.719,349.01,299.245Z"
                    fill="#080909"
                />
                <path
                    id="Path_62077"
                    data-name="Path 62077"
                    d="M205.186,301.9c-.168.083-.179-.409-.175-.655C205.128,301.267,205.241,301.54,205.186,301.9Z"
                    fill="#070707"
                />
                <path
                    id="Path_62078"
                    data-name="Path 62078"
                    d="M152.98,226.463a9.914,9.914,0,0,1-1.178-1.486c2.16-2.438,4.354-4.853,6.671-7.143a39.056,39.056,0,0,0,3.721-3.513,5.556,5.556,0,0,1,2.746.668c-3.513,3.657-7.209,6.977-11.3,10.664A4.051,4.051,0,0,0,152.98,226.463Z"
                    fill="#eee"
                />
                <path
                    id="Path_62079"
                    data-name="Path 62079"
                    d="M202.478,179.237c-.409-.19-.436-.362-.475-.8a5.093,5.093,0,0,1,1.952.273A5.526,5.526,0,0,1,202.478,179.237Z"
                    fill="#131313"
                />
                <path
                    id="Path_62080"
                    data-name="Path 62080"
                    d="M192.987,210.044c-4.568,4.4-11.179,8.01-13.259,13.375-3.807,9.82-10.057,17.376-16.682,24.971-4.327,4.961-8.7,9.886-14.019,15.932,13.922-1.463,26.115-3.8,38.642-10.24l-34.261,32.731a37.343,37.343,0,0,1-5.427-3.673,9.342,9.342,0,0,1-2.707-4.474c-.742-3.548-.95-7.208-1.829-11.089a1.008,1.008,0,0,1-.5-.708,3.222,3.222,0,0,1,1.487-1.7,41.909,41.909,0,0,0,4.143,1.317l.218-1.55-4.177-.244c4.808-6.7,9.663-13.364,14.4-20.113,1.8-2.559,3.3-5.322,4.973-7.967.61-.963,1.167-2.432,2.035-2.684,5.725-1.665,6.766-6.571,8.417-11.246,1.668-4.722,3.994-8.895,9.107-11.1,2.812-1.211,5.11-3.618,8.262-5.346A9.6,9.6,0,0,1,192.987,210.044Z"
                    fill="#080909"
                />
                <path
                    id="Path_62081"
                    data-name="Path 62081"
                    d="M196,205.165c.683,1.432,1.9,2.843,1.955,4.3.222,5.962.6,12-.1,17.886-.432,3.676-1.7,8.268-4.275,10.489-7.721,6.649-16.272,12.333-24.961,18.369-.576-.153-.69-.282-.8-.41,2.894-2.935,5.577-6.124,8.726-8.755,7.333-6.129,11.216-13.952,12.495-23.279a5.662,5.662,0,0,1,1.409-2.465c1.615-1.991,4.212-3.712,1.052-6.575-.237-.215.968-2.023,2.005-3.485A45.582,45.582,0,0,0,196,205.165Z"
                    fill="#080909"
                />
                <path
                    id="Path_62082"
                    data-name="Path 62082"
                    d="M221.852,184.577c-6.584,6.924-7.67,15.733-8.957,24.663-1.03,7.144-3.036,14.163-4.89,21.163-.54,2.041-2.043,3.828-3.1,5.732l-1.368-.439c.4-10.806.636-21.624,1.346-32.41a12.606,12.606,0,0,1,3.191-6.755,127.032,127.032,0,0,1,12.653-12.439A3.441,3.441,0,0,1,221.852,184.577Z"
                    fill="#0a0a0a"
                />
                <path
                    id="Path_62083"
                    data-name="Path 62083"
                    d="M182.849,301.832l18.578-22.577c3.25,7.564,1.188,14.474-5.069,17.765a104.538,104.538,0,0,1-12.7,5.2A1.382,1.382,0,0,1,182.849,301.832Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_62084"
                    data-name="Path 62084"
                    d="M152.319,244.384c1.605-.914,2.917-1.593,4.229-2.273l.936.774-11.443,12.527.718-5.485L136.672,254.5l-.878-1.845C141.2,249.979,146.615,247.3,152.319,244.384Z"
                    fill="#181818"
                />
                <path
                    id="Path_62085"
                    data-name="Path 62085"
                    d="M235.908,231.8c-1.212.825-2.151,1.439-3.091,2.053l-.958-1.047,15.177-14.131,1.439,1.444C244.377,223.941,240.279,227.764,235.908,231.8Z"
                    fill="#202020"
                />
                <path
                    id="Path_62086"
                    data-name="Path 62086"
                    d="M235.273,189.411,246.5,175.293l1.536,1.063a52.781,52.781,0,0,1-11.494,14.525A7.175,7.175,0,0,1,235.273,189.411Z"
                    fill="#060606"
                />
                <path
                    id="Path_62087"
                    data-name="Path 62087"
                    d="M225.952,178.979a80.234,80.234,0,0,1,7.782-6.869,3.883,3.883,0,0,1,1.13.428,96.318,96.318,0,0,1-7.716,7.047C226.493,179.253,226.242,179.087,225.952,178.979Z"
                    fill="#202020"
                />
                <path
                    id="Path_62088"
                    data-name="Path 62088"
                    d="M195.688,205.03a20.807,20.807,0,0,1-2.005,5.9c-.4-.075-.468-.232-.617-.635a27.693,27.693,0,0,0-.923-4.139A8.729,8.729,0,0,1,195.688,205.03Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_62089"
                    data-name="Path 62089"
                    d="M236.239,191.124a14.645,14.645,0,0,1-2.311,4.114l-1.967-1.312c.9-1.344,1.8-2.688,3.007-4.273C235.516,189.777,235.759,190.143,236.239,191.124Z"
                    fill="#060606"
                />
                <path
                    id="Path_62090"
                    data-name="Path 62090"
                    d="M193.848,191.3c-.046-.563-.044-.568.284-.443.522.2.716.269.911.341a7.275,7.275,0,0,0,.756,1.667,4.048,4.048,0,0,1-2.176,1.513,1.739,1.739,0,0,1-.769-.522A10.005,10.005,0,0,0,193.848,191.3Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_62091"
                    data-name="Path 62091"
                    d="M228.483,196.792c2.437,1.355,2.437,1.355-2.54,4.187C227.043,199.059,227.588,198.106,228.483,196.792Z"
                    fill="#060606"
                />
                <path
                    id="Path_62092"
                    data-name="Path 62092"
                    d="M233.753,262.625a5.4,5.4,0,0,1-2.452,2.546A5.4,5.4,0,0,1,233.753,262.625Z"
                    fill="#060606"
                />
                <path
                    id="Path_62093"
                    data-name="Path 62093"
                    d="M225.684,179.065a1.306,1.306,0,0,1,1.141.606,2.224,2.224,0,0,1-1.589,1.242,2.978,2.978,0,0,1-.957-.518A10.131,10.131,0,0,1,225.684,179.065Z"
                    fill="#0a0a0a"
                />
                <path
                    id="Path_62094"
                    data-name="Path 62094"
                    d="M223.791,202.8l1.907-2.177.76.562a6.726,6.726,0,0,1-1.771,2.046A1.387,1.387,0,0,1,223.791,202.8Z"
                    fill="#1c1c1c"
                />
                <path
                    id="Path_62095"
                    data-name="Path 62095"
                    d="M224.39,203.466a6.615,6.615,0,0,1-2,1.36,8.763,8.763,0,0,1,1.114-1.9C223.926,202.943,224.062,203.09,224.39,203.466Z"
                    fill="#1c1c1c"
                />
                <path
                    id="Path_62096"
                    data-name="Path 62096"
                    d="M152.965,226.482a1.272,1.272,0,0,1,.527-.517,19.843,19.843,0,0,1,2.138.015,4.928,4.928,0,0,1-2.374.765C152.972,226.544,152.951,226.5,152.965,226.482Z"
                    fill="#131313"
                />
                <path
                    id="Path_62097"
                    data-name="Path 62097"
                    d="M169.147,291.451a3.171,3.171,0,0,1-1.893.106,6.307,6.307,0,0,1,.71-.948C168.41,290.65,168.634,290.867,169.147,291.451Z"
                    fill="#040505"
                />
                <path
                    id="Path_62098"
                    data-name="Path 62098"
                    d="M168.322,256.386a6.715,6.715,0,0,1-2.091.254,4.885,4.885,0,0,1,1.261-.812A1.206,1.206,0,0,1,168.322,256.386Z"
                    fill="#080909"
                />
                <path
                    id="Path_62099"
                    data-name="Path 62099"
                    d="M221.043,183.989a5.392,5.392,0,0,1,1.813-1.38,6.124,6.124,0,0,1-.706,1.738C221.668,184.452,221.485,184.326,221.043,183.989Z"
                    fill="#0a0a0a"
                />
                <path
                    id="Path_62100"
                    data-name="Path 62100"
                    d="M224.959,180.982a5.834,5.834,0,0,1-1.838,1.3,7.389,7.389,0,0,1,.863-1.66C224.433,180.523,224.586,180.651,224.959,180.982Z"
                    fill="#0a0a0a"
                />
                <path
                    id="Path_62101"
                    data-name="Path 62101"
                    d="M234.049,172a2.071,2.071,0,0,1,1.38-1.421,1.467,1.467,0,0,1,.694.538,15.108,15.108,0,0,1-1.06,1.277C234.676,172.428,234.488,172.317,234.049,172Z"
                    fill="#202020"
                />
                <path
                    id="Path_62102"
                    data-name="Path 62102"
                    d="M183.31,302.348a7.666,7.666,0,0,1-2.09.284,5.03,5.03,0,0,1,1.3-.776C182.849,301.832,183.16,302.172,183.31,302.348Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_62103"
                    data-name="Path 62103"
                    d="M236.364,169.488l1.23-.318a.552.552,0,0,1-.389.684A2.01,2.01,0,0,1,236.364,169.488Z"
                    fill="#202020"
                />
                <path
                    id="Path_62104"
                    data-name="Path 62104"
                    d="M236.93,169.952a1.261,1.261,0,0,1-.56,1.092c-.35-.075-.453-.223-.672-.616a.866.866,0,0,1,.509-.856C236.364,169.488,236.748,169.789,236.93,169.952Z"
                    fill="#202020"
                />
                <path
                    id="Path_62105"
                    data-name="Path 62105"
                    d="M192.324,302.261c.26.054.285.343.31.633A.578.578,0,0,1,192.324,302.261Z"
                    fill="#040505"
                />
                <path
                    id="Path_62106"
                    data-name="Path 62106"
                    d="M193.327,194.506a.9.9,0,0,1-.739-.556C192.968,194,193.082,194.135,193.327,194.506Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_62107"
                    data-name="Path 62107"
                    d="M171.69,320.226c0,.3-.232.372-.46.445C171.308,320.447,171.387,320.222,171.69,320.226Z"
                    fill="#070707"
                />
                <path
                    id="Path_62108"
                    data-name="Path 62108"
                    d="M142.658,266.952c.291-.082.335.358.342.579A.448.448,0,0,1,142.658,266.952Z"
                    fill="#0d0d0d"
                />
                <path
                    id="Path_62109"
                    data-name="Path 62109"
                    d="M139.223,277.238c.3,0,.38.226.458.457C139.454,277.62,139.226,277.546,139.223,277.238Z"
                    fill="#040505"
                />
                <path
                    id="Path_62110"
                    data-name="Path 62110"
                    d="M195.269,190.995a1.3,1.3,0,0,1-1.094-.136,3.076,3.076,0,0,1,1.39-1.906,1.032,1.032,0,0,1,.58.156A12.155,12.155,0,0,1,195.269,190.995Z"
                    fill="#131313"
                />
                <path
                    id="Path_62111"
                    data-name="Path 62111"
                    d="M198.759,186.573a2.949,2.949,0,0,1,.2-1.744c.028-.08.52,0,.8.009A8.062,8.062,0,0,1,198.759,186.573Z"
                    fill="#fdfdfd"
                />
                <path
                    id="Path_62112"
                    data-name="Path 62112"
                    d="M195.854,188.889a5.8,5.8,0,0,1,.763-1.23,3.392,3.392,0,0,1-.266,1.29A.389.389,0,0,1,195.854,188.889Z"
                    fill="#131313"
                />
                <path
                    id="Path_62113"
                    data-name="Path 62113"
                    d="M236.718,380.62c1.3-1.007,2.93-2.528,3.485-2.2,1.417.825,3.381,2.578,3.259,3.768-.213,2.07-1.832,4-2.861,5.982l-1.718-.226C238.107,385.608,237.332,383.277,236.718,380.62Z"
                    fill="#eee"
                />
                <path
                    id="Path_62114"
                    data-name="Path 62114"
                    d="M294.636,200.892c1.456,1.365,2.576,2.7,4.331,4.137a8.421,8.421,0,0,1,2.055,1.051,1.332,1.332,0,0,0-.114-.131c2,5.308,4.181,10.6,6.048,16.012,3.105,9,8.006,16.547,16.211,21.729a87.528,87.528,0,0,1,7.783,5.79,6.4,6.4,0,0,1-2.111,2.263A5.966,5.966,0,0,1,327,252a7.622,7.622,0,0,0-2.116-.989c-4.308-.534-7.366-2.264-9.2-6.644-1.185-2.825-2.868-6.794-7.943-4.43-7.115-8.908-12.773-18.321-15.877-29.388-1.777-6.335-5.793-12.041-9.184-18.793C288.576,193.015,290.535,198.137,294.636,200.892Z"
                    fill="#060606"
                />
                <path
                    id="Path_62115"
                    data-name="Path 62115"
                    d="M326.846,252.3a3.5,3.5,0,0,1,1.821-.3c2.841.072,5.485.688,7.826.1,4.383-1.1,12.159,3.176,12.076,7.656-.033,1.768-2.47,3.491-4.19,5.241a14.575,14.575,0,0,1-5.291-1.053c-2.113-1.766-3.919-4.895-6.085-.943-.495-.262-.989-.524-1.743-.892-1.159-3.654-3.264-4.456-6.542-3.024a4.879,4.879,0,0,1-3.237.5,16.056,16.056,0,0,1-5.229-3.128c-.488-.464.211-3.346.664-3.425a41.812,41.812,0,0,1,6.457-.13A11.591,11.591,0,0,0,326.846,252.3Z"
                    fill="#080909"
                />
                <path
                    id="Path_62116"
                    data-name="Path 62116"
                    d="M331.728,279.654a37.6,37.6,0,0,1-.289,4.21l-1.775.012-.744-6.1,1-.379A22.114,22.114,0,0,1,331.728,279.654Z"
                    fill="#080909"
                />
                <path
                    id="Path_62117"
                    data-name="Path 62117"
                    d="M309.956,247.607a1.842,1.842,0,0,1-.209-1.181c0-.012.306,0,.47,0A2.055,2.055,0,0,1,309.956,247.607Z"
                    fill="#060606"
                />
                <path
                    id="Path_62118"
                    data-name="Path 62118"
                    d="M255.238,405.253c.289,0,.362.2.434.41C255.455,405.594,255.238,405.526,255.238,405.253Z"
                    fill="#040505"
                />
                <path
                    id="Path_62119"
                    data-name="Path 62119"
                    d="M274.715,172.035a3.544,3.544,0,0,1-.623,1.5l-.629-.546A5.65,5.65,0,0,1,274.715,172.035Z"
                    fill="#070708"
                />
                <path
                    id="Path_62120"
                    data-name="Path 62120"
                    d="M333.381,263.042c1.787-4,3.593-.867,5.56.606A30.177,30.177,0,0,1,333.381,263.042Z"
                    fill="#070708"
                />
                <path
                    id="Path_62121"
                    data-name="Path 62121"
                    d="M259.083,230.382c-.056-1.808-.056-3.243-.056-4.678l1.24-.809,3.571,3.917A22.594,22.594,0,0,1,259.083,230.382Z"
                    fill="#070708"
                />
                <path
                    id="Path_62122"
                    data-name="Path 62122"
                    d="M301.311,205.8a4.646,4.646,0,0,1-1.994-.74c-.147-.389-.007-.71.409-1.128A3.086,3.086,0,0,1,301.311,205.8Z"
                    fill="#f4f4f4"
                />
                <path
                    id="Path_62123"
                    data-name="Path 62123"
                    d="M144.636,264.74c1.378.032,2.77.114,4.162.195l-.218,1.55a20.638,20.638,0,0,1-3.857-1.362C144.549,264.774,144.65,264.789,144.636,264.74Z"
                    fill="#0d0d0d"
                />
            </g>{" "}
        </svg>
    );
}
